// console.log('before doc ready');
$(document).ready( function() {
  	// console.log('after doc ready');
    $('.close-this').on('click', function() {		
    	$('.upsell-lightbox-overlay').hide();		
      	$('.cart-lightbox-overlay').hide();	
      
    });  

  	$(document).on("click",".remove-link",function(e) {
      e.preventDefault();
      if($(this).hasClass('upsell_droplet_parent')){
       	var theUpsellID = $(this).attr('data-upsellbundleid');
        var theUpsellIdArray = [];
        $('.remove-droplet-'+theUpsellID).each(function() {
          var _this = $(this);
          theUpsellIdArray.push( _this.attr('data-cartvariantid') );
        });
        
        function removeBundleBundle() {
          if (theUpsellIdArray.length) {
            var request = theUpsellIdArray.shift();

            $.getJSON( '/cart.js', function (cart, textStatus) {
              $.each(cart.items, function(key, value) {

                if ( value.variant_id == request && value.properties['_labelMSUpsellBundleId'] === theUpsellID ) {
                 $.ajax({
                    url: '/cart/change',
                    dataType: 'json',
                    type: 'post',
                    data: 'line='+(key+1)+'&quantity=0',
                    success: function(message) {
                      removeBundleBundle();
                    }
                  });
                  return false;
                }
              });
            });
          }else{
            updateCartButton();
          }
        }
        removeBundleBundle();
      }else{
        $.ajax({
          url: $(this).attr('href'),
          dataType: 'json',
          type: 'post',
          success: function(message) {
            updateCartButton();
          }
        });
      }
	});
  function updateCartButton(){
    var extraPrice = 0;

    $.getJSON( '/cart.js', function (cart, textStatus) {
      $('.cart-count-text').find('.count').html(cart.item_count);
      $('.header-tools').find('.bag-count').html(cart.item_count);


      $('#bag-droplet').html('');
      cart.items.forEach(function(item, index) {
        var priceStr = item.line_price/100;
        var propertyStr = '';
        var upsell_product = false;
        var upsell_bundle = false;
        var upsell_id = '';

        for (var key in item.properties) {
          if(key == '_charge')
            upsell_product = true;
          if(key == '_labelMSUpsellBundleId'){
            upsell_bundle = true;
            upsell_id = item.properties[key];
          }

          if(key.charAt(0) != '_' && item.properties[key] != ''){
            propertyStr += '<li>' + key + ': <span>' + item.properties[key] + '</span></li>';
          }
          if(key == '_labelVariantPrices'){
            extraPrice += parseInt(item.properties[key])*item.quantity;
            priceStr += parseInt(item.properties[key])*item.quantity/100;
          }
        }

        item.variant_options.forEach(function(option, i) {
          if(option != 'Default Title')
            propertyStr += '<li>' + option +'</li>';
        });

        var classStr = '';
        var upsellStr = '';
        if(upsell_bundle){
          classStr = (upsell_product?'upsell_droplet_child':'upsell_droplet_parent')+' remove-droplet-' + upsell_id;
          upsellStr = 'data-upsellbundleid="' + upsell_id + '" data-cartvariantid="' + item.variant_id + '"';
        }

        var styleStr = '';
        if(index > 1) {
          styleStr = 'style="display:none;"';
        }
        $('#bag-droplet').append('<div class="product variant-' + item.variant_id + '" data-variant="' + item.variant_id + '"' + styleStr + '><a href="' + item.url + '"><img src="' +  item.image + '"></a><ul class="product-info"><li><h3><a href="' + item.url + '">' + item.product_title + '</a></h3></li>' + propertyStr + '<li class="qty">Qty: <span>' + item.quantity + '</span></li><li class="price">Price: <span>$' + priceStr.toFixed(2) + '</span></li></ul><a class="remove-link ' + classStr + '" href="/cart/change?line=' + (index+1) + '&quantity=0" ' + upsellStr + '>- Remove</a></div>');

      });
      var price = (cart.total_price + extraPrice)/100;


      $('#bag-droplet').append('<div class="totals"><h4 id="droplet-count"><span class="count">' + cart.item_count + '</span>&nbsp;<span>Items In Bag</span></h4><h4>Subtotal: <span class="subtotal">$' + price.toFixed(2) + '</span></h4><p class="message"><em>Taxes and shipping not included</em></p><p><a href="/cart" class="view-bag">View Your Bag</a></p><a href="/cart" class="button bigtext fullwidth btn-checkout">Checkout</a></div>');


    });
  }
  
  	// custom collection sidebar, hide team that doesn't belong to the group.
    if ( $('.grouplicense').length > -1 ) {
        $('.grouplicense').on('click', function(e) {
              e.preventDefault();
              var gl = $(this).data('team');

              $('.product-list-item:not(.'+gl+')').hide();
              $('.product-list-item.' + gl ).show();
        });
    }
  
  
  	// Shopify Review App.. to add in the product description tab.
  	var reviewContent = $('#shopify-product-reviews');
	$('.review-content').prepend(  reviewContent );


   /* if ( $('.spr-reviews').length != 0 ) {
      	$('.section-title').removeClass('active');
      	$('.section-content').removeClass('active');
      	$('.tc-review').addClass('active');
    }*/

    $('.navigation-first-tier').on('mouseenter', function() {
		$('.menu_cover').addClass('show');
    }).on('mouseleave', function() {
      	$('.menu_cover').removeClass('show');
    });
  
  	$('.regular-nav.has-dropdown').on('mouseenter', function() {
      	$(this).addClass('active');
    }).on('mouseleave', function() {
      	$(this).removeClass('active');
    });
});

if ( typeof(productTagCollection) !== 'undefined' ) { 
  console.log('productTagCollection: ' + productTagCollection);
} else {
  console.log('productTagCollection: undefined');
}

if ( typeof(productTagCollection) !== 'undefined' ) { 

  var theImageSuffix = '';
  if ( shopifyTemplate == 'product' && imageRemoveCache != '' ) {
      theImageSuffix = '?'+imageRemoveCache;
  }

  var assetNoImage = '//labeldaddy.com/cdn/shop/t/375/assets/no-image.png?v=325118';
  var assetURL = assetNoImage.split('no-image.png'); 

  setTimeout(function() {
    $('.product-main-image').removeClass('zoom-active zoom-enabled');
  }, 2000);

  $(window).resize(function () {
    $('.canvas').css({
      "width":"100%",
      "height":"100%"

    });
  });
  
  var isBGWhite = false;
  var iconLabelSelected = 'default';
  var bgBackground = '';
  var bgBackgroundColor = 'rgb(252, 127, 9)';
  var bgBackgroundColorDefault = '#FFFFFF';
  var image = ''; //cleanup others

  var productTagC = productTagCollection.toLowerCase();
  var asset_url = ( '//labeldaddy.com/cdn/shop/files/no-image.png?v=325118' ).split('no-image.png');

  var canvas = document.getElementById('canvas');
  var canvas1 = document.getElementById('canvas1');
  var thumb_canv = document.getElementById('thumb_canv');
  var context = canvas.getContext('2d');
  var context1 = canvas1.getContext('2d');
  var thumb_context = thumb_canv.getContext('2d');
  var width = document.getElementById('canvas-parent').offsetWidth;            
  var height = width;    

  renderCanvas();
  loadFonts();
  productform_control_added();
  
  function renderCanvas() {

    console.log('ran once');

      // Make canvas square
      canvas.style.width = width + 'px';
      canvas.style.height = height + 'px';      
      canvas1.style.width = width + 'px';
      canvas1.style.height = height + 'px';  

      // Make canvas twice the size
      canvas.width = width * 2;
      canvas.height = width * 2;     
      canvas1.width = width * 2;
      canvas1.height = width * 2;    
          var image = '';

      //variables for Full Name Canvas
      var cTxKey = '',
        dataLine = '',
        cTxLineType = '',
        cTxFontSize = '',
        cTxFontFace = '',
        cTxColor = '',
        cTxText = '',
        cTxAlign = '',
        cTxWidth = '',
        cTxWeight = '';

    //console.log('page load');

    if (hasBasic) {
      bgBackground = asset_url[0] + productTagC + '_basic_no-icon-bg_700x700.png' + asset_url[1];
    } else {
      bgBackground = asset_url[0] + productTagC + '_basic_transparent_default-bg_700x700.png' + asset_url[1];
    }
    console.log('bgBackground: ' + bgBackground);

    image = new Image();
    // Load image and draw it to canvas
    image.onload = function(){
        context.clearRect(0, 0, canvas.width, canvas.height);
        context.restore();
        context.fillStyle=bgBackgroundColorDefault;
        context.fillRect(0,0,canvas.width, canvas.height);        
        context.drawImage(image, 0, 0, canvas.width, canvas.height);
    }
    image.src = bgBackground;        

    image = new Image();
    // Load image and draw it to canvas
    image.onload = function(){
        context1.clearRect(0, 0, canvas1.width, canvas1.height);
        context1.restore();
        context1.fillStyle=bgBackgroundColorDefault;
        context1.fillRect(0,0,canvas1.width, canvas1.height);        
        context1.drawImage(image, 0, 0, canvas1.width, canvas1.height);
    }
    image.src = bgBackground;    

    // Load image and draw it to thumbnail canvas
    image = new Image();
    image.onload = function(){
        thumb_context.clearRect(0, 0, thumb_canv.width, thumb_canv.height);
        thumb_context.restore();
        thumb_context.fillStyle=bgBackgroundColorDefault;
        thumb_context.fillRect(0,0,thumb_canv.width, thumb_canv.height);        
        thumb_context.drawImage(image, 0, 0, thumb_canv.width, thumb_canv.height);
    }
    image.src = bgBackground;   
    $('#thumb_canv').parents('a').attr('href', bgBackground).attr('color', "#FFFFFF");
  }

  function loadFonts() {
      var fontCSSURL = '//labeldaddy.com/cdn/shop/t/375/assets/customizer-font.css?v=20731304463298520571750735037';
      // console.log("ajax cploc complete: " + fontCSSURL);

      $("<link/>", {
        rel: "stylesheet",
        type: "text/css",
        href: fontCSSURL
      }).appendTo("head");    
  }

  function productform_control_added() {

    $('.bold_options').remove();
    var productTagC = productTagCollection.toLowerCase();

    var contentOptions = "<div class='label_options label_options_loaded'></div>";
    $('#product-form').find('.product-quantity').before(contentOptions);

    function addOptionsTextbox( pText, pContent, pPlaceholder, pRequired, pUseDefaultValue, pMaxLength, pClass) {
      var cTitle = pText;
      var cContent = pContent;    
      var cPropertiesString = "";

      if (pUseDefaultValue === "true") {
        cPropertiesString += " class='use-default'";
      }

      if (pMaxLength != "") {
        cPropertiesString += " maxlength='" + pMaxLength + "'";      
      }
      //console.log('cPropertiesString: ' + cPropertiesString);

      var contentTextbox = "<div class='" + pClass + " label_option label_option_textbox'><label><span class='label_option_title'>" + cTitle + pRequired + "</span><span class='label_option_element'><input placeholder='" + pPlaceholder + "' name='properties[" + cTitle + "]' type='text' id='" + cContent + "' " + cPropertiesString + "></span></label></div>";

      $('.label_option_set').append(contentTextbox);
    }



    function addOptionsSelect( pText, pContent, pIsRequire) {

      var cTitle = pText;
      var requireT = '';
      var cContent = pContent;

      var radioContentSplit = cContent.split('|');
      var swatchType = radioContentSplit[0];

      if(radioContentSplit.length > 0){
        requireT = radioContentSplit[0].toLowerCase();

        if(pIsRequire === "true")
          requireT = requireT+"*";
      }

      var contentRadio = "<div class='label_option'><span class='label_option_title selecttitle'>" + requireT + "</span><h3 class='label-title'>" + cTitle + "</h3><select id='" + swatchType + "' class='label_option_element'>";

      for (var i = 0; i < radioContentSplit.length; i++) {
       /* if (swatchType === "Swatch-collection") {
          console.log('radioContentSplit[i]: ' + radioContentSplit[i]);
          if (radioContentSplit[i] === "Basic") {
            hasBasic = true;
          }
        } 
        else*/ if (swatchType === "Swatch-font") {
          var fontString = radioContentSplit[i].split('-');
          var fontClass = fontString[0].replace(/ /g,'-');     
        }

        contentRadio += "<option class='label_option_value " + fontClass + "' value='" + radioContentSplit[i] + "' data-option_value_key='" + i + "'>" + radioContentSplit[i] + "</option>";
      }

      contentRadio += "</select></div>";
      $('.label_option_set').append(contentRadio);


      //Replace select with select2 list
      $('#' + swatchType).select2({
        templateResult: formatItem,
        minimumResultsForSearch: -1
      });

      function formatItem (state) {
        if (!state.id) { return state.text; }
        var $state = $(
          '<span class="' + state.element.className + '">' + state.text + '</span>'
        );
        return $state;
      }

    }

    function addOptionsRadio( pText, pContent, pIsRequire) {
      var cTitle;
      if(pIsRequire === "true"){
        cTitle = pText+"*";
      }else{
        cTitle = pText;
      }
      var cContent = pContent;

      var contentRadio = "<div class='label_option label_option_radio'><span class='label_option_element'>";

      var radioContentSplit = cContent.split('|');

      for (var i = 0; i < radioContentSplit.length; i++) {
        if (radioContentSplit[i] === "Lookup") {
          contentRadio += lookupGlobalColorSettings();             
        } 
        else if(radioContentSplit[i].indexOf('=$') !== -1){
          var splitText = radioContentSplit[i].split('=');
          contentRadio += "<span class='label_option_value'><label><span class='label_option_value_element'><input type='radio' name='properties[" + pText +"]' value='" + splitText[0] + "' data-option_value_key='" + i + "'></span><span class='label_option_value_title'>" + splitText[0] + "</span><span class='label_option_value_price'><span class='money' data-currency='USD'>" + splitText[1] + "</span></span></label></span>";
        } 
        else{
          contentRadio += "<span class='label_option_value'><label><span class='label_option_value_element'><input type='radio' name='properties[" + pText +"]' value='" + radioContentSplit[i] + "' data-option_value_key='" + i + "'></span><span class='label_option_value_title'>" + radioContentSplit[i] + "</span></label></span>";
        }
      }

      contentRadio += "</span></div>";
      $('.label_option_set').append(contentRadio);
    }

    function lookupGlobalColorSettings() {

      var globalColorSettingsJSON = assetURL[0] + 'basic-icon-settings.json' + assetURL[1];
      var contentRadio = "";

       $.ajax({
          type: 'GET',
          url: globalColorSettingsJSON,
          dataType: 'json',
          async: false,
          success: function(results) {
            var jasonObject = results; 

            $.each( jasonObject, function ( key, value ) {

                  var fontColorString = "";
                  if (typeof value.FontColor != 'undefined') 
                      fontColorString = " data-fontcolor='" + value.FontColor + "'";

                  var bgString = "";
                  if (value.Background === 'override')
                      bgString = " data-background='" + value.Background + "'";

                  //console.log("fontColorString: " + fontColorString);

                  //console.log("key = " + key + " value = " + value.Icon + " " + value.Hex + "-" + value.ColorType + " " + value.Name); 

                  var defaultString = '';
                  if (value.Default === "true")
                    defaultString = " class='default'";

                  //console.log('value.Default: ' + value.Default);
                  contentRadio += "<span class='label_option_value'><label><span class='label_option_value_element'><input" + defaultString + " type='radio' name='properties[Color:]' value='" + value.Name + "' data-option_value_key='" + key + "'" + fontColorString + bgString + "></span><span class='label_option_value_title'>#" + value.Hex + "|" + value.ColorType + "|" + value.Name + "|" + value.Icon + "</span></label></span>";
            });

            //console.log("contentRadio " + contentRadio);    		          
          }
        });       

      return contentRadio; 
    }

    function addOptionsCheckbox( pText, pContent, pPrice, pIsRequire) {
      var cTitle = pText;
      var cContent = pContent;

      var cPrice = parseInt(pPrice)*100;
      //var firstRate = Shopify.Cart.ShippingCalculator.formatRate(pPrice);
      console.log("pPrice = " + pPrice + "pPrice = " + pPrice);
      var contentCheckbox = "<div class='label_option label_option_checkbox'><label>";

      contentCheckbox += "<span class='label_option_element'><input type='checkbox' ><input type='hidden', name='properties[" + cContent +"]' value='' ></span><span class='label_option_title'>" + cTitle + "</span>";
      contentCheckbox += "<span class='label_option_value_price'><span class='money' data-currency='USD' >" + "$" + pPrice + "</span></span>";

      contentCheckbox += "</label></div>";
      $('.label_option_set').append(contentCheckbox);
      var shopCurrency = Shop.currency;
      var moneyFormat = Currency.cookie.read();
      if(moneyFormat === null){
          moneyFormat = 'USD';
      }
      console.log("moneyFormat = " + moneyFormat);
      Currency.convertAll(shopCurrency, moneyFormat);
    }

      var labelTitleContent = "<div class='label_option_product_title'></div>";
      $('.label_options_loaded').html(labelTitleContent);
      $('.label_options_loaded').find('.label_option_product_title').after("<div class='label_option_set'></div>");


      var assetNoImage = '//labeldaddy.com/cdn/shop/t/375/assets/no-image.png?v=325118';
      var assetURL = assetNoImage.split('no-image.png');  

      var coJSONstring = 'cojson_'+productTagC;
      var newCOLoc = assetURL[0]+coJSONstring+'.json' + assetURL[1]; 
      //var newCOLoc = "http://labeldaddy.airarena.net/asset/json/"+coJSONstring+'.json';   
      console.log('newCOLoc: ' + newCOLoc);

          $.ajax({
                type: 'GET',
                url: newCOLoc,
                dataType: 'json',
                success: function(results) {
                      console.log('cojson');

                      var coLocResult = results;

                       $.each(coLocResult, function(key, value) {
                         //console.log("value_require" + key + "value = " + value.type);
                         if(value.type === "textbox"){
                           //console.log('value.maxlength: ' + value.maxlength);
                           if(value.require === "true"){                           
                              addOptionsTextbox(value.title,value.content,value.placeholder,"*","false",value.maxlength,value.class);                           
                           }else{
                              addOptionsTextbox(value.title,value.content,value.placeholder,"",value.usedefaultvalue,value.maxlength,value.class);
                           }
                         }else if(value.type === "radio"){
                           addOptionsRadio(value.title,value.content, value.require);
                         }else if(value.type === "select"){
                           addOptionsSelect(value.title,value.content, value.require);
                         }else if(value.type === "checkbox"){
                           addOptionsCheckbox(value.title,value.content, value.price, value.require); 
                         }


                      });
                  product_options_rendered();
                },
                error: function(e) {
                  console.log (newCOLoc);
                  console.log("error:", e);
                  // product_options_rendered();
                }
          });

  }

  function product_options_rendered() {
    //console.log("product_options_rendered");

    // set the default background color of the product customizer
    if ( $('.label_options').length > 0 ) {
      $('.product-main-image').css('background-color','#fff');
      //$('.main-img').css('background-color','rgb(252, 127, 9)');    

      $('#quantity').keypress(function(e) {
          if ( e.which == 13 ) return false;
      });

      $('.label_option_element').find('input').keypress(function(e){
      	  loadPreview();
          if ( e.which == 13 ) return false;
      });    

    }

    function loadPreview() {
     	console.log("loadPreview: " + bgBackground);
    	image = new Image();  
        // Load image and draw it to canvas
        image.onload = function(){
          context.clearRect(0, 0, canvas.width, canvas.height);
          context.restore();
          context.fillRect(0,0,canvas.width, canvas.height);        
          context.drawImage(image, 0, 0, canvas.width, canvas.height);
        }
        image.src = bgBackground;   
        $('.line-label').show();         
    }

    // Canvas code for ONE line text - used for first name, last name, labels and phone text fields..
    function loadCanvasText( pKey, pLineType, pFontSize, pFontFace, pColor, pText, pAlign, pWeight, firstLoad, embossObject) {
          //console.log("loadCanvasText: " + pKey);
            cTxKey = pKey,
            cTxText = pText,
            cTxAlign = pAlign,
            cTxWeight = pWeight,
            cTxFontSize = pFontSize,
            cTxFontFace = pFontFace,
            cTxColor = pColor,
            cTxLineType = pLineType;

          //console.log('loadCanvasText = ' + pText);
        var cTxLoad = firstLoad;

      //$('.product-thumbnails').find('canvas').trigger( "click" );

        $('.divwidth').css('font-family',cTxFontFace);

        var canV = document.getElementById('textCanvas').setAttribute( 'height', $('.text-width'+cTxKey+':visible').height()*1.2 );
        var tCtx = document.getElementById('textCanvas').getContext('2d');
        var imageElem = $('.cpimg.img'+cTxKey+':visible');
        var valueDefault = cTxText;


          tCtx.canvas.width = $('.text-width'+cTxKey+':visible').width() * 2.4;
          tCtx.textAlign=cTxAlign;


        if (pAlign === "center" ) {
           var canvasWAlignment = tCtx.canvas.width/2;
        } else if (pAlign === 'left' ) {
           var canvasWAlignment = 0;
        } else if (pAlign === 'right') {
           var canvasWAlignment = tCtx.canvas.width;
        } else {
           var canvasWAlignment = tCtx.canvas.width/2;
        }

          if ( embossObject ) {
            var cTxEmbossObject = JSON.parse(embossObject);
            tCtx.save();
            tCtx.lineWidth = cTxEmbossObject.shadowlinewidth;
            tCtx.strokeStyle = '#'+cTxEmbossObject.shadowcolor;
            tCtx.font = cTxWeight + " " + cTxFontSize+"px " + cTxFontFace;
            tCtx.textBaseline = 'alphabetic';
            tCtx.lineJoin = 'round';
            tCtx.scale(1,1);
            tCtx.strokeText( valueDefault, canvasWAlignment + 3, (cTxFontSize*1.2)+2 );
            tCtx.restore();

            tCtx.save();
            tCtx.lineWidth = cTxEmbossObject.outlinewidth;
            tCtx.strokeStyle = '#'+cTxEmbossObject.outlinecolor;
            tCtx.font = cTxWeight + " " + cTxFontSize+"px " + cTxFontFace;
            tCtx.textBaseline = 'alphabetic';
            tCtx.lineJoin = 'round';
            tCtx.scale(1,1);
            tCtx.fillStyle = '#'+cTxColor;
            tCtx.strokeText( valueDefault, canvasWAlignment, (cTxFontSize*1.2) );
            tCtx.fillText( valueDefault, canvasWAlignment, (cTxFontSize*1.2) );
            tCtx.restore();


          } else {
            tCtx.font = cTxWeight + " " + cTxFontSize+"px " + cTxFontFace;
            tCtx.fillStyle = "#"+cTxColor;
            tCtx.fillText( valueDefault, canvasWAlignment, (cTxFontSize*1.2) );
          }


          function adjustImageHeight () {
              var imageHeight = $('.cpimg.img'+cTxKey+':visible').height() - 2;
              imageElem.css({'max-height':imageElem.parents('.line-span').height() , 'width': 'auto'});
          }



          if ( cTxLoad === true ) {
              adjustImageHeight();
          } else {
              adjustImageHeight();

          }

          imageElem.attr('src', tCtx.canvas.toDataURL());

    }


    // Canvas code for automatically converting one line to two line text - multiline used for full name.
    function loadCanvasFull( pKey, pLineType, pFontSize, pFontFace, pColor, pText, pAlign, pWeight, firstLoad, embossObject) {
          //console.log("loadCanvasFull: " + pKey);
            cTxKey = pKey,
            cTxText = pText,
            cTxAlign = pAlign,
            cTxWeight = pWeight,
            cTxFontSize = pFontSize,
            cTxFontFace = pFontFace,
            cTxColor = pColor,
            cTxLineType = pLineType;

        var cTxLoad = firstLoad;
        var valueDefault = cTxText;
        var words = valueDefault.split(' '),
            lineCount = 0,
            i,
            y = cTxFontSize;
        var twoLine = false;
        var canvasFontHeightAttr = $('.'+pFontFace.toLowerCase().replace(/\s/g,"-")).attr('data-height');
        var canvasFontHeight = canvasFontHeightAttr.split('--');
        var canvasFontLineHeight = canvasFontHeight[1].replace('lineheight-','');

      //$('.product-thumbnails').find('canvas').trigger( "click" );
      if(words[1]){
         if(words[0].length == 1 || words[1].length == 1 || (words[1].length == 2 && words[1].indexOf('.')>-1)){
             words = [words.join(' ')];
         }
      }

        var canvasWAlignment;
      var imageElem = $('.cpimg.img'+cTxKey+':visible');

      $('.divwidth').css('font-family',cTxFontFace);

      // loop every single word
      for (i = 0; i < words.length; i++) {
          y = cTxFontSize;
          var wordCount = (words.length) / 2;
          var wordCounter = 0;
          var printThis1 = '';
          var printThis2 = '';

          // we will divide all words by two.. so we can show the first group in one line,
          // 2nd group in 2nd line
          $.each(words, function(key, value) {
            if ( wordCounter < wordCount ) {
                  printThis1 += value + ' ';
            } else {
                        printThis2 += value + ' ';
                  twoLine = true;
            }
            wordCounter++;
          });
      }


      function setCanvasValue( canvasHeight, canvasWidth ) {
        //console.log('loadCanvasFull Width = ' + canvasWidth);
          var canV = document.getElementById('textCanvas').setAttribute( 'height',  canvasHeight );
          var tCtx = document.getElementById('textCanvas').getContext('2d');
          cTxWidth = $('.text-width'+cTxKey).width()*2 + canvasWidth;

          if (pAlign === "center" ) {
             canvasWAlignment = cTxWidth/2;
          } else if (pAlign === 'left' ) {
             canvasWAlignment = 0;
          } else if (pAlign === 'right') {
             canvasWAlignment = cTxWidth;
          } else {
             canvasWAlignment = cTxWidth/2;
          }

      }


      // if no 2nd Group of words
      if ( printThis2.length == 0  ) {
          //console.log("printThis2.length == 0");

          var canvasHeight = $('.text-width'+cTxKey+':visible').height()*1.2,
              canvasWidth = $('.text-width'+cTxKey+':visible').width()/2;
              setCanvasValue( canvasHeight, canvasWidth );


                  if ( embossObject ) {
                    var cTxEmbossObject = JSON.parse(embossObject);
                    tCtx.canvas.width = cTxWidth;
                    tCtx.textAlign=cTxAlign;
                    tCtx.save();
                    tCtx.lineWidth = cTxEmbossObject.shadowlinewidth;
                    tCtx.strokeStyle = '#'+cTxEmbossObject.shadowcolor;
                    tCtx.font = cTxWeight + " " + cTxFontSize+"px " + cTxFontFace;
                    tCtx.textBaseline = 'alphabetic';
                    tCtx.lineJoin = 'round';
                    tCtx.scale(1,1);
                    tCtx.strokeText( printThis1, canvasWAlignment,  (y*1.2)+2 );
                    tCtx.restore();

                    tCtx.save();
                    tCtx.lineWidth = cTxEmbossObject.outlinewidth;
                    tCtx.strokeStyle = '#'+cTxEmbossObject.outlinecolor;
                    tCtx.font = cTxWeight + " " + cTxFontSize+"px " + cTxFontFace;
                    tCtx.textBaseline = 'alphabetic';
                    tCtx.lineJoin = 'round';
                    tCtx.scale(1,1);
                    tCtx.fillStyle = '#'+cTxColor;
                    tCtx.strokeText( printThis1, canvasWAlignment,  (y*1.2) );
                    tCtx.fillText(printThis1, canvasWAlignment,  (y*1.2) );
                    tCtx.restore();

                  } else {
                    tCtx.canvas.width = cTxWidth;
                    tCtx.textAlign=cTxAlign;
                    tCtx.font = cTxWeight + " " + cTxFontSize+"px "+cTxFontFace;
                    tCtx.fillStyle = "#"+cTxColor;
                    tCtx.fillText( printThis1, canvasWAlignment,  (y*1.2) );
                  }


          // if no 2nd line, we will try to move the elements around the fullname close to it
          $.each( imageElem.parents('span.line-span').siblings('span.line-span'), function() {
                var $this = $(this);
            if ( $this.hasClass('down') ) {
                var dataMove = parseInt($this.data('move').replace('%',''));
                $this.css('top', (dataMove + 4)+"%" );
            } else if ( $this.hasClass('up') ) {
                var dataMove = parseInt($this.data('move').replace('%',''));
                $this.css('top', (dataMove - 3)+"%" );
            }
          });


      } else if ( (printThis2.length + printThis1.length) <= 10 ) { // 1st Group and 2nd Group characters are combined
          //console.log("else if printThis2.length");

            var canvasHeight = $('.text-width'+cTxKey+':visible').height()*1.2,
                canvasWidth = $('.text-width'+cTxKey+':visible').width()/2;
                setCanvasValue( canvasHeight, canvasWidth );

            if ( embossObject ) {
              var cTxEmbossObject = JSON.parse(embossObject);

              tCtx.canvas.width = cTxWidth;
              tCtx.textAlign=cTxAlign;
              tCtx.save();
              tCtx.lineWidth = cTxEmbossObject.shadowlinewidth;
              tCtx.strokeStyle = '#'+cTxEmbossObject.shadowcolor;
              tCtx.font = cTxWeight + " " + cTxFontSize+"px " + cTxFontFace;
              tCtx.textBaseline = 'alphabetic';
              tCtx.lineJoin = 'round';
              tCtx.scale(1,1);
              tCtx.strokeText( printThis1 + printThis2, canvasWAlignment, (y*1.2)+2 );
              tCtx.restore();

              tCtx.save();
              tCtx.lineWidth = cTxEmbossObject.outlinewidth;
              tCtx.strokeStyle = '#'+cTxEmbossObject.outlinecolor;
              tCtx.font = cTxWeight + " " + cTxFontSize+"px " + cTxFontFace;
              tCtx.textBaseline = 'alphabetic';
              tCtx.lineJoin = 'round';
              tCtx.scale(1,1);
              tCtx.fillStyle = '#'+cTxColor;
              tCtx.strokeText( printThis1 + printThis2, canvasWAlignment, (y*1.2) );
              tCtx.fillText( printThis1 + printThis2, canvasWAlignment, (y*1.2) );
              tCtx.restore();


            } else {
              tCtx.canvas.width = cTxWidth;
              tCtx.textAlign=cTxAlign;
              tCtx.font = cTxWeight + " " + cTxFontSize+"px "+cTxFontFace;
              tCtx.fillStyle = "#"+cTxColor;
              tCtx.fillText( printThis1 + printThis2, canvasWAlignment, (y*1.2) );
            }

            // if there's no 2nd line, we will try to move the elements close to the fullname
            $.each( imageElem.parents('span.line-span').siblings('span.line-span'), function() {
                  var $this = $(this);
              if ( $this.hasClass('down') ) {
                  var dataMove = parseInt($this.data('move').replace('%',''));
                  $this.css('top', (dataMove + 4)+"%" );
              } else if ( $this.hasClass('up') ) {
                  var dataMove = parseInt($this.data('move').replace('%',''));
                  $this.css('top', (dataMove - 3) +"%" );
              }
            });



      } else {
          //console.log("else");
            if ( printThis1.length > printThis2.length ) {
                var printHalf = printThis2.length / 2;
                  $('.text-width'+cTxKey).text(printThis1 + printThis2.substr(printHalf));
            } else {
                var printHalf = printThis1.length / 2;
                  $('.text-width'+cTxKey).text(printThis2 + printThis1.substr(printHalf));
            }

            var canvasHeight = $('.text-width'+cTxKey+':visible').height() * canvasFontHeight[0],
                canvasWidth = $('.text-width'+cTxKey+':visible').width()/5;

            setCanvasValue( canvasHeight, canvasWidth );


            if ( embossObject ) {
              var cTxEmbossObject = JSON.parse(embossObject);

              tCtx.canvas.width = cTxWidth;
              tCtx.textAlign=cTxAlign;
              tCtx.save();
              tCtx.lineWidth = cTxEmbossObject.shadowlinewidth;
              tCtx.strokeStyle = '#'+cTxEmbossObject.shadowcolor;
              tCtx.font = cTxWeight + " " + cTxFontSize+"px " + cTxFontFace;
              tCtx.textBaseline = 'alphabetic';
              tCtx.lineJoin = 'round';
              tCtx.scale(1,1);
              tCtx.strokeText(printThis1, canvasWAlignment, (y*1.2)+2);
              tCtx.strokeText(printThis2, canvasWAlignment, (cTxFontSize*canvasFontLineHeight)+2);
              tCtx.restore();

              tCtx.save();
              tCtx.lineWidth = cTxEmbossObject.outlinewidth;
              tCtx.strokeStyle = '#'+cTxEmbossObject.outlinecolor;
              tCtx.font = cTxWeight + " " + cTxFontSize+"px " + cTxFontFace;
              tCtx.textBaseline = 'alphabetic';
              tCtx.lineJoin = 'round';
              tCtx.scale(1,1);
              tCtx.fillStyle = '#'+cTxColor;

              tCtx.strokeText(printThis1, canvasWAlignment, (y*1.2));
              tCtx.strokeText(printThis2, canvasWAlignment, (cTxFontSize*canvasFontLineHeight));
              tCtx.fillText(printThis1, canvasWAlignment, (y*1.2));
              tCtx.fillText(printThis2, canvasWAlignment, (cTxFontSize*canvasFontLineHeight));
              tCtx.restore();


            } else {
              tCtx.canvas.width = cTxWidth;
              tCtx.textAlign=cTxAlign;
              tCtx.font = cTxWeight + " " + cTxFontSize+"px "+cTxFontFace;
              tCtx.fillStyle = "#"+cTxColor;
              tCtx.fillText(printThis1, canvasWAlignment, (y*1.2));
              tCtx.fillText(printThis2, canvasWAlignment, (cTxFontSize*canvasFontLineHeight));
            }


            // if we moved, we will reset it back to it's original location
            $.each( imageElem.parents('span.line-span').siblings('span.line-span'), function() {
              //console.log("$.each( imageElem");
              var $this = $(this);
              if ( $this.hasClass('down') ) {
                  //console.log("down");
                  var dataMove = parseInt($this.data('move').replace('%',''));
                  $this.css('top', (dataMove)+"%" );
              } else if ( $this.hasClass('up') ) {
                  //console.log("up: " + $this.attr('class'));
                  var dataMove = parseInt($this.data('move').replace('%',''));
                  $this.css('top', (dataMove)+"%" );
              }
            });


      }

          function adjustImageHeight () {
              var imageHeight = $('.cpimg.img'+cTxKey+':visible').height() - 2;
              imageElem.css({'max-height':imageElem.parents('.line-span').height() , 'width': 'auto'});
          }

          if ( cTxLoad === true ) {
              //loadCanvasFull( pKey, pLineType, pFontSize, pFontFace, pColor, pText, pAlign, pWeight, firstLoad);
              //setTimeout(adjustImageHeight, 100);
              adjustImageHeight();
          } else {
              adjustImageHeight();
          }


          imageElem.attr('src', tCtx.canvas.toDataURL());
    }




    // load_address
    function loadCanvasAddress( pKey, pLineType, pFontSize, pFontFace, pColor, pText, pExtra, pAlign, pWeight, firstLoad, embossObject) {
            cTxKey = pKey,
            cTxText = pText,
            cTxAlign = pAlign,
            cTxWeight = pWeight,
            cTxFontSize = pFontSize,
            cTxFontFace = pFontFace,
            cTxColor = pColor,
            cTxLineType = pLineType;

      console.log('loadCanvasAddress pText = ' + pText + ' pExtra = ' + pExtra);
      var cTxLoad = firstLoad;
      var valueDefault = cTxText;
      var words = '',
          lineCount = 0,
          i,
          y = cTxFontSize;
      var twoLine = false;
      var canvasFontHeightAttr = $('.'+pFontFace.toLowerCase().replace(/\s/g,"-")).attr('data-height');
      console.log("aaaaa = " + pFontFace);
      var canvasFontHeight = canvasFontHeightAttr.split('--');
      var canvasFontLineHeight = canvasFontHeight[1].replace('lineheight-','');

      if(words[1]){
        if(words[1].length == 1 || (words[1].length == 2 && words[1].indexOf('.')>-1)){
          words = [words.join(' ')];
        }
      }

        var canvasWAlignment;
        var imageElem = $('.cpimg.img'+cTxKey+':visible');

      $('.product-thumbnails').find('canvas').trigger( "click" );
      $('.divwidth').css('font-family',cTxFontFace);

      // loop every single word
      for (i = 0; i < words.length; i++) {
          y = cTxFontSize;
          var wordCount = (words.length) / 2;
          var wordCounter = 0;
          var printThis1 = '';
          var printThis2 = '';

          // we will divide all words by two.. so we can show the first group in one line,
          // 2nd group in 2nd line
          $.each(words, function(key, value) {
            if ( wordCounter < wordCount ) {
                  printThis1 += value + ' ';
            } else {
                        printThis2 += value + ' ';
                  twoLine = true;
            }
            wordCounter++;
          });
      }

      printThis1 = pText;
      printThis2 = pExtra;
      twoLine = true;

      function setCanvasValue( canvasHeight, canvasWidth ) {
          var canV = document.getElementById('textCanvas').setAttribute( 'height',  canvasHeight );
          var tCtx = document.getElementById('textCanvas').getContext('2d');
          cTxWidth = $('.text-width'+cTxKey+':visible').width()*2 + canvasWidth;

          if (pAlign === "center" ) {
             canvasWAlignment = cTxWidth/2;
          } else if (pAlign === 'left' ) {
             canvasWAlignment = 0;
          } else if (pAlign === 'right') {
             canvasWAlignment = cTxWidth;

          } else {
             canvasWAlignment = cTxWidth/2;
          }

      }



          if(printThis1.length + printThis2.length){
            if ( printThis1.length > printThis2.length ) {
              var printHalf = printThis2.length / 2;
              $('.text-width'+cTxKey).text(printThis1 + printThis2.substr(printHalf));
            } else {
              var printHalf = printThis1.length / 2;
              $('.text-width'+cTxKey).text(printThis2 + printThis1.substr(printHalf));
            }
          }

            var canvasHeight = $('.text-width'+cTxKey+':visible').height() * canvasFontHeight[0],
                canvasWidth = $('.text-width'+cTxKey+':visible').width()/5;
              console.log('canvasFontHeight[0] = ' + canvasFontHeight[0]);
            setCanvasValue( canvasHeight, canvasWidth );


            if ( embossObject ) {
              var cTxEmbossObject = JSON.parse(embossObject);

              tCtx.canvas.width = cTxWidth;
              tCtx.textAlign=cTxAlign;
              tCtx.save();
              tCtx.lineWidth = cTxEmbossObject.shadowlinewidth;
              tCtx.strokeStyle = '#'+cTxEmbossObject.shadowcolor;
              tCtx.font = cTxWeight + " " + cTxFontSize+"px " + cTxFontFace;
              tCtx.textBaseline = 'alphabetic';
              tCtx.lineJoin = 'round';
              tCtx.scale(1,1);
              tCtx.strokeText(printThis1, canvasWAlignment, (y*1.2)+2);
              tCtx.strokeText(printThis2, canvasWAlignment, (cTxFontSize*canvasFontLineHeight)+2);
              tCtx.restore();

              tCtx.save();
              tCtx.lineWidth = cTxEmbossObject.outlinewidth;
              tCtx.strokeStyle = '#'+cTxEmbossObject.outlinecolor;
              tCtx.font = cTxWeight + " " + cTxFontSize+"px " + cTxFontFace;
              tCtx.textBaseline = 'alphabetic';
              tCtx.lineJoin = 'round';
              tCtx.scale(1,1);
              tCtx.fillStyle = '#'+cTxColor;

              tCtx.strokeText(printThis1, canvasWAlignment, (y*1.2));
              tCtx.strokeText(printThis2, canvasWAlignment, (cTxFontSize*canvasFontLineHeight));
              tCtx.fillText(printThis1, canvasWAlignment, (y*1.2));
              tCtx.fillText(printThis2, canvasWAlignment, (cTxFontSize*canvasFontLineHeight));
              tCtx.restore();


            } else {
              tCtx.canvas.width = cTxWidth;
              tCtx.textAlign=cTxAlign;
              tCtx.font = cTxWeight + " " + cTxFontSize+"px "+cTxFontFace;
              tCtx.fillStyle = "#"+cTxColor;
              tCtx.fillText(printThis1, canvasWAlignment, (y*1.2));
              tCtx.fillText(printThis2, canvasWAlignment, (cTxFontSize*canvasFontLineHeight));
            }


            // if we moved, we will reset it back to it's original location
            $.each( imageElem.parents('span.line-span').siblings('span.line-span'), function() {
                  var $this = $(this);
              if ( $this.hasClass('down') ) {
                  var dataMove = parseInt($this.data('move').replace('%',''));
                  $this.css('top', (dataMove)+"%" );
              } else if ( $this.hasClass('up') ) {
                  var dataMove = parseInt($this.data('move').replace('%',''));
                  $this.css('top', (dataMove)+"%" );
              }
            });




          function adjustImageHeight () {
              var imageHeight = $('.cpimg.img'+cTxKey+':visible').height() - 2;
              imageElem.css({'max-height':imageElem.parents('.line-span').height() , 'width': 'auto'});
          }

          if ( cTxLoad === true ) {
                     //loadCanvasFull( pKey, pLineType, pFontSize, pFontFace, pColor, pText, pAlign, pWeight, firstLoad);
               //setTimeout(adjustImageHeight, 100);
               adjustImageHeight();
          } else {
              adjustImageHeight();
          }

          imageElem.attr('src', tCtx.canvas.toDataURL());

    } // end load canvas address






    //=========Load JSON Coordinates============

    var assetNoImage = '//labeldaddy.com/cdn/shop/t/375/assets/no-image.png?v=325118';
    var assetURL = assetNoImage.split('no-image.png');  

    var ccJSONstring = 'ccjson_'+productTagC;
    var newCCLoc = assetURL[0] +ccJSONstring+'.json' + assetURL[1];
  //  var newCCLoc = "//cdn.shopify.com/s/files/1/1255/8361/t/83/assets/" +ccJSONstring+'.json' + assetURL[1];
    var cpJSONstring = 'cpjson_'+productTagC;
    var newCPLoc = assetURL[0]+cpJSONstring+'.json' + assetURL[1];
  //  var newCPLoc = "//cdn.shopify.com/s/files/1/1255/8361/t/83/assets/"+cpJSONstring+'.json' + assetURL[1];


    var lineDiv = $('.line-label');  

    function callBasicJson( productTagJ , iconFontColor , iconFontFamily) {
      	//console.log('iconFontColor = ' + iconFontColor + 'iconFontFamily = ' + iconFontFamily);
         lineDiv.html('');            
         var basicFontColor, basicFontFamily;

        $.ajax({
            type: 'GET',
            url: newCPLoc,
            dataType: 'json',
          success: function(results) {


            var cpLocResult = results;
            //console.log(productTagJ);
            //console.log(cpLocResult[productTagJ]);
            $.each(cpLocResult[productTagJ], function(key, value) {


              if ( (iconFontColor ===  '000000' ||iconFontColor != false) && iconFontFamily != false ) {
                  basicFontColor = iconFontColor, 
                  basicFontFamily = iconFontFamily;

              } else {
                  basicFontColor = value.fontcolor, 
                  basicFontFamily = value.fontfamily;            
              }     
              //console.log("basicFontColor = " + basicFontColor + "basicFontFamily = " + basicFontFamily);
              var lineType = value.class;
              if ( String(key).indexOf('line') > -1 ) {
                var inputVal = value.default;
                var divWidthVal = value.default;

                if ( value.class === 'firstname' ) {
                  if ( firstName.val().length != 0  ) {
                     inputVal = firstName.val();
                      $('.firstname').prev('.divwidth').text( firstName.val() );
                      divWidthVal = firstName.val();
                  }

                } else if ( value.class === 'lastname' ) {
                  if ( lastName.val().length != 0  ) {
                     inputVal = lastName.val();
                      $('.lastname').prev('.divwidth').text( lastName.val() );
                      divWidthVal = lastName.val();
                  }

                } else if ( value.class === 'phone' ) {
                  if ( telphone.val().length != 0  ) {
                     inputVal = telphone.val();
                      $('.phone').prev('.divwidth').text( telphone.val() );
                      divWidthVal = telphone.val();
                  }

                }  else if ( value.class === 'onlyphone' ) {
                  if ( phone.val().length != 0  ) {
                     inputVal = phone.val();
                      $('.onlyphone').prev('.divwidth').text( phone.val() );
                      divWidthVal = phone.val();
                  }

                }  else if ( value.class === 'onlyemail' ) {
                  if ( email.val().length != 0  ) {
                     inputVal = email.val();
                      $('.onlyemail').prev('.divwidth').text( email.val() );
                      divWidthVal = email.val();
                  }

                } else if ( value.class == 'fullname' ) {
                  if ( fullName.val().length != 0  ) {
                     inputVal = fullName.val();
                      $('.fullname').prev('.divwidth').text( fullName.val() );
                      divWidthVal = fullName.val();
                  }
                } else if ( value.class == 'longname' ) {
                  if ( fullName.val().length != 0  ) {
                     inputVal = fullName.val();
                      $('.longname').prev('.divwidth').text( fullName.val() );
                      divWidthVal = fullName.val();
                  }
                } else if ( value.class == 'allergies' ) {
                  if ( allergies.val().length != 0  ) {
                     inputVal = allergies.val();
                      $('.allergies').prev('.divwidth').text( allergies.val() );
                      divWidthVal = allergies.val();
                  }
                } else if ( value.class == 'monogram' ) {
                  if ( monogram.val().length != 0  ) {
                     inputVal = monogram.val();
                      $('.monogram').prev('.divwidth').text(monogram.val() );
                      divWidthVal = monogram.val();
                  }
                }else if ( value.class == 'text1' ) {
                  if ( text1.val().length != 0  ) {
                     inputVal = text1.val();
                      $('.text1').prev('.divwidth').text(text1.val() );
                      divWidthVal = text1.val();
                  }
                }else if ( value.class == 'text2' ) {
                  if ( text2.val().length != 0  ) {
                     inputVal = text2.val();
                      $('.text2').prev('.divwidth').text(text2.val() );
                      divWidthVal = text2.val();
                  }
                }else if ( value.class == 'text3' ) {
                  if ( text3.val().length != 0  ) {
                     inputVal = text3.val();
                      $('.text3').prev('.divwidth').text(text3.val() );
                      divWidthVal = text3.val();
                  }
                }else if ( value.class == 'text4' ) {
                  if ( text4.val().length != 0  ) {
                     inputVal = text4.val();
                      $('.text4').prev('.divwidth').text(text4.val() );
                      divWidthVal = text4.val();
                  }
                }else if ( value.class == 'text5' ) {
                  if ( text5.val().length != 0  ) {
                     inputVal = text5.val();
                      $('.text5').prev('.divwidth').text(text5.val() );
                      divWidthVal = text5.val();
                  }
                } else if ( value.class == 'address' ) {
                  if ( address.val().length != 0  ) {
                      inputVal = address.val();
                      $('.address').prev('.divwidth').text( address.val() );
                      divWidthVal = address.val();
                  }
                } else {
                      divWidthVal = value.default;
                }
                  //for emboss basic

                var lineSpan = $('<div class="divwidth text-width'+key+'" style="font-family: '+basicFontFamily+'; font-size:'+value.fontsize/2+'px; line-height:'+(value.fontsize*1.4)+'px">'+divWidthVal+'</div><span class="line-span '+ lineType + " " + key + " " + value.move +'" data-move="'+value.ycoordinate+'" data-line="'+key+'" data-class="'+value.class+'" data-text="'+inputVal+'" data-fontsize="'+value.fontsize+'" data-fontface="'+basicFontFamily+'" data-fontcolor="'+basicFontColor+'" data-fontweight="'+value.fontweight+'" data-alignment="'+value.alignment+'" data-width="'+value.width+'"><img class="cpimg img'+key+'" style="float:'+value.alignment+'"> </span>');

                lineDiv.append(lineSpan);
                $('.'+key).css({
                  'height': value.height,
                  'display': 'block',
                  'width': value.width,
                  'left': value.xcoordinate,
                  'top': value.ycoordinate,
                  'height': value.height
                });


                if ( value.hasOwnProperty('emboss') ) {
                    isLineEmboss = true;
                    lineEmbossArr = value.emboss;
                    fontColorHx1 = value.fontcolor;
                    collectionFontFamily1 = value.fontfamily;
                    $('.'+key).attr('data-emboss',JSON.stringify(value.emboss))
                              .attr('data-fontcolor', fontColorHx1 )
                              .attr('data-fontface', collectionFontFamily1);
                } else if ( value.hasOwnProperty('usedefaultfont') && value.usedefaultfont === 'false' ) {
                    fontColorHx1 = value.fontcolor;
                    collectionFontFamily1 = value.fontfamily;
                    $('.'+key).attr('data-fontcolor', fontColorHx1 )
                              .attr('data-fontface', collectionFontFamily1);
                }                

                if ( lineType === 'fullname' || lineType === 'allergies' || lineType === 'address' ) {
                      loadCanvasFull( key, lineType, value.fontsize, basicFontFamily, basicFontColor, inputVal, value.alignment, value.fontweight, false, JSON.stringify(value.emboss));
                } else {
                      loadCanvasText( key, lineType, value.fontsize, basicFontFamily, basicFontColor, inputVal, value.alignment, value.fontweight, false, JSON.stringify(value.emboss));
                }

                $('.line-label').attr({'data-fontstyle':basicFontFamily, 'data-color':basicFontColor});
             }

            });

            }
        });

     }  



    //========Swatches and Background==========

    // Remove swatch control and add class like swatch-'..' so that we can customize that swatch section

    $('option').each(function() {
        var optionVal = $(this).val().toLowerCase();

        if ( optionVal === 'swatch-icon' ) {
          $(this).parents('.label_option_element').addClass('swatch-icon');
          $(this).parents('.label_option').addClass('icon-section');
          $(this).parents('select.label_option_element').prepend('<option style="display:none;" value="" disabled selected>Select Icon</option>');
          $(this).remove();
        } else if ( optionVal === 'swatch-collection' ) {
          $(this).parents('.label_option_element').addClass('swatch-collection');
          $(this).parents('.label_option').addClass('collection-section');
          $(this).parents('select.label_option_element').prepend('<option style="display:none;" value="" disabled selected>Select...</option>');
          $(this).remove();
        } else if ( optionVal === 'swatch-font' ) {
          $(this).parents('.label_option_element').addClass('swatch-font');
          $(this).parents('.label_option').addClass('collection-font');
          $(this).parents('select.label_option_element').prepend('<option style="display:none;" value="" disabled selected>Select Font</option>');
          $(this).remove();
        } else if ( optionVal === 'swatch-colortype' ) {
          $(this).parents('.label_option_element').addClass('swatch-colortype');
          $(this).parents('.label_option').addClass('collection-colortype');
          $(this).parents('select.label_option_element').prepend('<option style="display:none;" value="" disabled selected>Select Label Color Type</option>');
          $(this).remove();
        } else if ( optionVal === 'swatch-style' ) {
          $(this).parents('.label_option_element').addClass('swatch-style');
          $(this).parents('.label_option').addClass('twostep-style');
          $(this).parents('select.label_option_element').prepend('<option style="display:none;" value="" disabled selected>Select Style</option>');
          $(this).remove();
        }
    });

    $('input[type="radio"]').each(function() {
      var inputRadio = $(this).val().toLowerCase();

      if ( inputRadio === 'swatch-icon' ) {
          $(this).parents('.label_option_element').addClass('swatch-icon');
          $(this).parents('.label_option').addClass('icon-section');
          $(this).parents('.label_option_value').remove();
      } else if ( inputRadio === 'swatch-color' ) {
          $(this).parents('.label_option_element').addClass('swatch-color');
          $(this).parents('.label_option_radio').addClass('collection-color');
          $(this).parents('.label_option_value').remove();
      }
    });

     $('.swatch-icon').find('label').each(function() {
        var iconTitle = $(this).find('.label_option_value_title').text();
        var labelBGSrc = asset_url[0] + "icon_basic_55x55_" + iconTitle.toLowerCase().replace(/\s/g,"") + '.png' + asset_url[1];

        $(this).find('.label_option_value_title').text(iconTitle);
        $(this).find('input[type="radio"]').val(iconTitle).css('display','none');
        $(this).find('.label_option_value_element').after('<img src="'+labelBGSrc+'">');

    }); 

    $('.swatch-style').find('label').each(function( key, value ) {
        var collectionTitle = $(this).find('.label_option_value_title').text();
        var labelBGSrc = asset_url[0] + collectionTitle.toLowerCase().replace(/\s/g,"-") + '.png'+theImageSuffix;

        $(this).parents('.label_option_value').addClass(collectionTitle.toLowerCase().replace(/\s/g,"-"));
        $(this).find('input[type="radio"]').css('display','none');
        $(this).find('.label_option_value_title').hide();
        $(this).find('.label_option_value_element').after('<img src="'+labelBGSrc+'">');
        if ( key == 0 ) {
          $('.license-line-properties').prepend('<input type="hidden" class="collection-type" name="properties[_Icon URL]" value="'+ labelBGSrc +'">');
          //$(this).find('img').addClass('style-active');
        }
    });

    $('.swatch-label').find('label').each(function() {
        var labelColorName = $(this).find('.label_option_value_title').text().slice(8); // color name
        var labelColorHex = $(this).find('.label_option_value_title').text().substr(0,7);

        $(this).prepend('<span class="colorhex" style="background-color:'+labelColorHex+'"></span>');

        if ( labelColorName.indexOf('White') > -1 ) {
          $(this).find('input[type="radio"]').addClass('special-white');
        }
        $(this).find('.label_option_value_title').text('');
        $(this).find('input[type="radio"]').val(labelColorName).css('display','none').attr('data-hex',labelColorHex);
    });

    $('.swatch-color').find('label').each(function() {
        var IconColorSettings = $(this).find('.label_option_value_title').text().split('|');

        var fontColorName = IconColorSettings[2];
        var fontColorHex = IconColorSettings[0];
        //var t = fontColorName.split(' ');
        var fontColorType = IconColorSettings[1];

        var icon = "";
        icon = IconColorSettings[3];

        var iconClass = "All";
        if (typeof icon != "undefined")
          iconClass = icon;

        //t.shift();
        //fontColorName = t.join(' ');
        //console.log("iconClass: " + iconClass);
        $(this).prepend('<span class="colorhex" style="background-color:'+fontColorHex+'"></span>');

        if ( fontColorName.indexOf('White') > -1 ) {
          $('.colorhex').css('border','');
          $(this).find('input[type="radio"]').addClass('special-white');
        }
        $(this).find('.label_option_value_title').text('');
        $(this).find('input[type="radio"]').val(fontColorName).css('display','none').addClass(iconClass + ' Color ' + fontColorType).attr('data-hex',fontColorHex);

    });

    $('select.swatch-colortype').find('option').each(function() {
      var colorType = $(this).val();
      $(this).val(colorType.replace(' ','_'));
    });

    $('select.swatch-font').find('option').each(function() {
      var fontFullName = $(this).text();
      var t = fontFullName.split('-');
      if(t.length > 1){
        $(this).val(t[0]);
        $(this).text(t[1]);
      }
    });

    //Add placeholder for textbox

    $("input[id='Full Name']").addClass('full-name');
    if ($("input[id='Full Name']").attr('placeholder') === "undefined") {
      $("input[id='Full Name']").attr('placeholder','Full Name');
    }

    $("input[id='First Name]']").addClass('first-name').attr('placeholder','First Name');;
    $("input[id='Last Name']").addClass('last-name').attr('placeholder','Last Name');;
    $("input[id='Phone or Email']").addClass('tel').attr('placeholder','Phone or Email');
    $("input[id='Phone']").addClass('phone-initial').attr('placeholder','Phone');
    $("input[id='Email']").addClass('email-initial').attr('placeholder','Email');
    $("input[id='Phone Number']").addClass('tel').attr('placeholder','Phone Number');
    $("input[id='Allergies']").addClass('allergy').attr('placeholder','Allergies');
    $("input[id='Monogram Initial']").addClass('monogram-initial').attr('placeholder','Monogram Initial').attr('maxlength','1');
    $("input[id='Jersey Number']").addClass('jerseynumber').attr('placeholder','Jersey Number');

    $("input[id='Text 1']").addClass('text-1');  
    if ($("input[id='Text 1']").attr('maxlength') === undefined) {
      $("input[id='Text 1']").attr('maxlength','20');
    }
    if ($("input[id='Text 1']").attr('placeholder') === "undefined") {
      $("input[id='Text 1']").attr('placeholder','Please return to:');
    }

    $("input[id='Text 2']").addClass('text-2');
    if ($("input[id='Text 2']").attr('maxlength') === undefined) {
      $("input[id='Text 2']").attr('maxlength','20');
    }
    if ($("input[id='Text 2']").attr('placeholder') === "undefined") {
      $("input[id='Text 2']").attr('placeholder','This belongs to:');
    }

    $("input[id='Text 3']").addClass('text-3');
    if ($("input[id='Text 3']").attr('maxlength') === undefined) {
      $("input[id='Text 3']").attr('maxlength','20');
    }

    $("input[id='Text 4']").addClass('text-4');
    if ($("input[id='Text 4']").attr('maxlength') === undefined) {
      $("input[id='Text 4']").attr('maxlength','20');
    }

    $("input[id='Text 5']").addClass('text-5');
    if ($("input[id='Text 5']").attr('maxlength') === undefined) {
      $("input[id='Text 5']").attr('maxlength','20');
    }

    if ( $("input[id='Monogram Initial']").length != 0) {
      $("input[id='Street Address']").addClass('street-address all-address')
    }

    if ( $("input[id='Street Address']").length != 0 && $('.full-address').length == 0  ) {
      $("input[id='Street Address']").addClass('street-address all-address').attr('placeholder','Street Address');
      $("input[id='City']").addClass('city-address all-address').attr('placeholder','City');
      $("input[id='State']").addClass('state-address all-address').attr('placeholder','State').parents('.label_option.label_option_textbox').addClass('parent-state');
      $("input[id='Zip Code']").addClass('zip-address all-address').attr('placeholder','Zip Code').parents('.label_option.label_option_textbox').addClass('parent-zip');
      $("input[id='Street Address']").before('<input type="hidden" class="ctstzp-address" value="">');
      $("input[id='Street Address']").before('<input type="hidden" class="single-address" value="">');
    }

    var firstName = $('.first-name'),
        justName = $('.just-name'),
        lastName = $('.last-name'),
        fullName = $('.full-name'),
        allergies = $('.allergy'),
        cityAddress = $('.ctstzp-address'),
        singleAddress = $('.single-address'),
        allAddress = $('.all-address'),
        telphone = $('.tel'),
        phone = $('.phone-initial'),
        email = $('.email-initial'),
        monogram = $('.monogram-initial'),
        text1 = $('.text-1'),
        text2 = $('.text-2'),
        text3 = $('.text-3'),
        text4 = $('.text-4'),
        text5 = $('.text-5'),
        jerseynumber = $('.jerseynumber');

        allAddress.on('keyup', function() {
          if ( $(this).hasClass('state-address') ) {
              $(this).val( $(this).val().toUpperCase() );
          }

          var ctstzpAddressVal = $('.city-address').val() + ' ' + $('.state-address').val().toUpperCase() + ' ' + $('.zip-address').val(),
              streetAddressVal = $('.street-address').val(),
              ctstzpAddressValTrim = ctstzpAddressVal.trim();

              singleAddress.val( streetAddressVal.trim() );
              cityAddress.val( ctstzpAddressValTrim );

             $('.address').each(function() {
                 var $this = $(this);
                 var dataLine = $this.data('line'),
                     cTxLineType = $this.data('class'),
                     cTxFontSize = $this.data('fontsize'),
                     cTxFontFamily = $this.attr('data-fontface'),
                     cTxColor = $this.attr('data-fontcolor'),
                     cTxAlign = $this.data('alignment'),
                     cTxWidth = $this.width(),
                     cTxWeight = $this.data('fontweight');

                 $(this).attr('data-text', streetAddressVal );

                  var val = ctstzpAddressVal + streetAddressVal;
                      val = val.trim();
                  console.log(val.length);
                 if(val.length){
                   if ( streetAddressVal.length > ctstzpAddressVal  ) {
                     $(this).prev('.divwidth').text(streetAddressVal);
                   } else {
                     $(this).prev('.divwidth').text(ctstzpAddressVal);
                   }
                 }

                 if ( $this.attr('data-emboss') != undefined ) {
                   loadCanvasAddress( dataLine, cTxLineType, cTxFontSize, cTxFontFamily, cTxColor, streetAddressVal.trim(), ctstzpAddressValTrim, cTxAlign, cTxWeight, false, JSON.stringify($this.data('emboss')) );
                 } else {
                   loadCanvasAddress( dataLine, cTxLineType, cTxFontSize, cTxFontFamily, cTxColor, streetAddressVal.trim(), ctstzpAddressValTrim, cTxAlign, cTxWeight, false );
                 }

             });
       });

    lastName.on('keyup', function() {
          var lastNameVal = $(this).val();

        $('.lastname').each(function() {
          console.log("astname').each(functio");
            var $this = $(this);
            var dataLine = $this.data('line'),
                cTxLineType = $this.data('class'),
                cTxFontSize = $this.data('fontsize'),
                cTxFontFamily = $this.attr('data-fontface'),
                cTxColor = $this.attr('data-fontcolor'),
                cTxAlign = $this.data('alignment'),
                cTxWeight = $this.data('fontweight');

            $(this).attr('data-text', lastNameVal);

            if ( lastNameVal.length > 10  ) {
              $(this).prev('.divwidth').text(lastNameVal);
            }

            if ( $this.attr('data-emboss') != undefined ) {
              loadCanvasText( dataLine, cTxLineType, cTxFontSize, cTxFontFamily, cTxColor, lastNameVal, cTxAlign, cTxWeight, false, JSON.stringify($this.data('emboss')) );
            } else {
            loadCanvasText( dataLine, cTxLineType, cTxFontSize, cTxFontFamily, cTxColor, lastNameVal, cTxAlign, cTxWeight, false);
            }

        });

    });

      var tCtx = document.getElementById('textCanvas').getContext('2d');
      var imageElem = $('.cpimg');


      justName.on('keyup', function() {
          var justNameVal = $(this).val();

        $('.longname').each(function() {
              var $this = $(this);
            var dataLine = $this.data('line'),
                cTxLineType = $this.data('class'),
                cTxFontSize = $this.data('fontsize'),
                    cTxFontFamily = $this.attr('data-fontface'),
                cTxColor = $this.attr('data-fontcolor'),
                cTxAlign = $this.data('alignment'),
                cTxWeight = $this.data('fontweight');

            $(this).attr('data-text', justNameVal);

            if ( justNameVal.length > 0  ) {
              $(this).prev('.divwidth').text(justNameVal);
            }

            if ( $this.attr('data-emboss') != undefined ) {
              loadCanvasText( dataLine, cTxLineType, cTxFontSize, cTxFontFamily, cTxColor, justNameVal, cTxAlign, cTxWeight, false, JSON.stringify($this.data('emboss')) );
            } else {
              loadCanvasText( dataLine, cTxLineType, cTxFontSize, cTxFontFamily, cTxColor, justNameVal, cTxAlign, cTxWeight, false);
            }

        });

      });


    firstName.on('keyup', function() {
          var firstNameVal = $(this).val();

      $('.firstname').each(function() {
        console.log("$('.firstname').each(functio");
          var $this = $(this);
          var dataLine = $this.data('line'),
              cTxLineType = $this.data('class'),
              cTxFontSize = $this.data('fontsize'),
              cTxFontFamily = $this.attr('data-fontface'),
              cTxColor = $this.attr('data-fontcolor'),
              cTxAlign = $this.data('alignment'),
              cTxWeight = $this.data('fontweight');

          $(this).attr('data-text', firstNameVal);

          if ( firstNameVal.length > 0  ) {
            $(this).prev('.divwidth').text(firstNameVal);
          }

          if ( $this.attr('data-emboss') != undefined ) {
            loadCanvasText( dataLine, cTxLineType, cTxFontSize, cTxFontFamily, cTxColor, firstNameVal, cTxAlign, cTxWeight, false, JSON.stringify($this.data('emboss')) );
          } else {
          loadCanvasText( dataLine, cTxLineType, cTxFontSize, cTxFontFamily, cTxColor, firstNameVal, cTxAlign, cTxWeight, false);
          }

      });


    });

     allergies.on('keyup', function() {
          var allergiesVal = $(this).val();

          $('.allergies').each(function() {
              var $this = $(this);
              var dataLine = $this.data('line'),
                  cTxLineType = $this.data('class'),
                  cTxFontSize = $this.data('fontsize'),
                  cTxFontFamily = $this.attr('data-fontface'),
                  cTxColor = $this.attr('data-fontcolor'),
                  cTxAlign = $this.data('alignment'),
                  cTxWidth = $this.width(),
                  cTxWeight = $this.data('fontweight');

              $(this).attr('data-text', allergiesVal );

              if ( allergiesVal.length > 0  ) {
                $(this).prev('.divwidth').text(allergiesVal);
              }

              if ( $this.attr('data-emboss') != undefined ) {
                loadCanvasFull( dataLine, cTxLineType, cTxFontSize, cTxFontFamily, cTxColor, allergiesVal, cTxAlign, cTxWeight, false, JSON.stringify($this.data('emboss')) );
              } else {
                loadCanvasFull( dataLine, cTxLineType, cTxFontSize, cTxFontFamily, cTxColor, allergiesVal, cTxAlign, cTxWeight, false );
              }

          });
    });

    monogram.on('keyup', function() {
          var monogramVal = $(this).val();

          $('.monogram').each(function() {
              var $this = $(this);
              var dataLine = $this.data('line'),
                  cTxLineType = $this.data('class'),
                  cTxFontSize = $this.data('fontsize'),
                  cTxFontFamily = $this.attr('data-fontface'),
                  cTxColor = $this.attr('data-fontcolor'),
                  cTxAlign = $this.data('alignment'),
                  cTxWidth = $this.width(),
                  cTxWeight = $this.data('fontweight');

              $(this).attr('data-text', monogramVal );

              if ( monogramVal.length > 0  ) {
                $(this).prev('.divwidth').text(monogramVal);
              }

              if ( $this.attr('data-emboss') != undefined ) {
                loadCanvasText( dataLine, cTxLineType, cTxFontSize, cTxFontFamily, cTxColor, monogramVal, cTxAlign, cTxWeight, false, JSON.stringify($this.data('emboss')) );
              } else {
                loadCanvasText( dataLine, cTxLineType, cTxFontSize, cTxFontFamily, cTxColor, monogramVal, cTxAlign, cTxWeight, false );
              }

          });
    });

    text1.on('keyup', function() {
          var text1Val = $(this).val();

          $('.text1').each(function() {
              var $this = $(this);
              var dataLine = $this.data('line'),
                  cTxLineType = $this.data('class'),
                  cTxFontSize = $this.data('fontsize'),
                  cTxFontFamily = $this.attr('data-fontface'),
                  cTxColor = $this.attr('data-fontcolor'),
                  cTxAlign = $this.data('alignment'),
                  cTxWidth = $this.width(),
                  cTxWeight = $this.data('fontweight');

              $(this).attr('data-text', text1Val );

              if ( text1Val.length > 0  ) {
                $(this).prev('.divwidth').text(text1Val);
              }

              if ( $this.attr('data-emboss') != undefined ) {
                loadCanvasText( dataLine, cTxLineType, cTxFontSize, cTxFontFamily, cTxColor, text1Val, cTxAlign, cTxWeight, false, JSON.stringify($this.data('emboss')) );
              } else {
                loadCanvasText( dataLine, cTxLineType, cTxFontSize, cTxFontFamily, cTxColor, text1Val, cTxAlign, cTxWeight, false );
              }

          });
    });

    text2.on('keyup', function() {
          var text2Val = $(this).val();

          $('.text2').each(function() {
              var $this = $(this);
              var dataLine = $this.data('line'),
                  cTxLineType = $this.data('class'),
                  cTxFontSize = $this.data('fontsize'),
                  cTxFontFamily = $this.attr('data-fontface'),
                  cTxColor = $this.attr('data-fontcolor'),
                  cTxAlign = $this.data('alignment'),
                  cTxWidth = $this.width(),
                  cTxWeight = $this.data('fontweight');

              $(this).attr('data-text', text2Val );

              if ( text2Val.length > 0  ) {
                $(this).prev('.divwidth').text(text2Val);
              }

              if ( $this.attr('data-emboss') != undefined ) {
                loadCanvasText( dataLine, cTxLineType, cTxFontSize, cTxFontFamily, cTxColor, text2Val, cTxAlign, cTxWeight, false, JSON.stringify($this.data('emboss')) );
              } else {
                loadCanvasText( dataLine, cTxLineType, cTxFontSize, cTxFontFamily, cTxColor, text2Val, cTxAlign, cTxWeight, false );
              }

          });
    });

    text3.on('keyup', function() {
          var text3Val = $(this).val();

          $('.text3').each(function() {
              var $this = $(this);
              var dataLine = $this.data('line'),
                  cTxLineType = $this.data('class'),
                  cTxFontSize = $this.data('fontsize'),
                  cTxFontFamily = $this.attr('data-fontface'),
                  cTxColor = $this.attr('data-fontcolor'),
                  cTxAlign = $this.data('alignment'),
                  cTxWidth = $this.width(),
                  cTxWeight = $this.data('fontweight');

              $(this).attr('data-text', text3Val );

              if ( text3Val.length > 0  ) {
                $(this).prev('.divwidth').text(text3Val);
              }

              if ( $this.attr('data-emboss') != undefined ) {
                loadCanvasText( dataLine, cTxLineType, cTxFontSize, cTxFontFamily, cTxColor, text3Val, cTxAlign, cTxWeight, false, JSON.stringify($this.data('emboss')) );
              } else {
                loadCanvasText( dataLine, cTxLineType, cTxFontSize, cTxFontFamily, cTxColor, text3Val, cTxAlign, cTxWeight, false );
              }

          });
    });

    text4.on('keyup', function() {
          var text4Val = $(this).val();

          $('.text4').each(function() {
              var $this = $(this);
              var dataLine = $this.data('line'),
                  cTxLineType = $this.data('class'),
                  cTxFontSize = $this.data('fontsize'),
                  cTxFontFamily = $this.attr('data-fontface'),
                  cTxColor = $this.attr('data-fontcolor'),
                  cTxAlign = $this.data('alignment'),
                  cTxWidth = $this.width(),
                  cTxWeight = $this.data('fontweight');

              $(this).attr('data-text', text4Val );

              if ( text4Val.length > 0  ) {
                $(this).prev('.divwidth').text(text4Val);
              }

              if ( $this.attr('data-emboss') != undefined ) {
                loadCanvasText( dataLine, cTxLineType, cTxFontSize, cTxFontFamily, cTxColor, text4Val, cTxAlign, cTxWeight, false, JSON.stringify($this.data('emboss')) );
              } else {
                loadCanvasText( dataLine, cTxLineType, cTxFontSize, cTxFontFamily, cTxColor, text4Val, cTxAlign, cTxWeight, false );
              }

          });
    });

    text5.on('keyup', function() {
          var text5Val = $(this).val();

          $('.text5').each(function() {
              var $this = $(this);
              var dataLine = $this.data('line'),
                  cTxLineType = $this.data('class'),
                  cTxFontSize = $this.data('fontsize'),
                  cTxFontFamily = $this.attr('data-fontface'),
                  cTxColor = $this.attr('data-fontcolor'),
                  cTxAlign = $this.data('alignment'),
                  cTxWidth = $this.width(),
                  cTxWeight = $this.data('fontweight');

              $(this).attr('data-text', text5Val );

              if ( text5Val.length > 0  ) {
                $(this).prev('.divwidth').text(text5Val);
              }

              if ( $this.attr('data-emboss') != undefined ) {
                loadCanvasText( dataLine, cTxLineType, cTxFontSize, cTxFontFamily, cTxColor, text5Val, cTxAlign, cTxWeight, false, JSON.stringify($this.data('emboss')) );
              } else {
                loadCanvasText( dataLine, cTxLineType, cTxFontSize, cTxFontFamily, cTxColor, text5Val, cTxAlign, cTxWeight, false );
              }

          });
    });

    fullName.on('keyup', function() {
          var fullNameVal = $(this).val();
          console.log('fullNameVal = ' + fullNameVal);

          $('.fullname').each(function() {
              var $this = $(this);
              var dataLine = $this.data('line'),
                  cTxLineType = $this.data('class'),
                  cTxFontSize = $this.data('fontsize'),
                  cTxFontFamily = $this.attr('data-fontface'),
                  cTxColor = $this.attr('data-fontcolor'),
                  cTxAlign = $this.data('alignment'),
                  cTxWidth = $this.width(),
                  cTxWeight = $this.data('fontweight');

              $(this).attr('data-text', fullNameVal);

              if ( fullNameVal.length > 0  ) {
                $(this).prev('.divwidth').text(fullNameVal);

              }

              if ( $this.attr('data-emboss') != undefined ) {
                loadCanvasFull( dataLine, cTxLineType, cTxFontSize, cTxFontFamily, cTxColor, fullNameVal, cTxAlign, cTxWeight, false, JSON.stringify($this.data('emboss')) );
              } else {
              loadCanvasFull( dataLine, cTxLineType, cTxFontSize, cTxFontFamily, cTxColor, fullNameVal, cTxAlign, cTxWeight, false );
              }

          });

          $('.longname').each(function() {
            console.log("$('.longname').each(function() {");
              var $this = $(this);
              var dataLine = $this.data('line'),
                  cTxLineType = $this.data('class'),
                  cTxFontSize = $this.data('fontsize'),
                  cTxFontFamily = $this.attr('data-fontface'),
                  cTxColor = $this.attr('data-fontcolor'),
                  cTxAlign = $this.data('alignment'),
                  cTxWeight = $this.data('fontweight');

              $(this).attr('data-text', fullNameVal);

            if ( fullNameVal.length > 0  ) {
              $(this).prev('.divwidth').text(fullNameVal);
            }

            if ( $this.attr('data-emboss') != undefined ) {
              loadCanvasText( dataLine, cTxLineType, cTxFontSize, cTxFontFamily, cTxColor, fullNameVal, cTxAlign, cTxWeight, false, JSON.stringify($this.data('emboss')) );
            } else {
              loadCanvasText( dataLine, cTxLineType, cTxFontSize, cTxFontFamily, cTxColor, fullNameVal, cTxAlign, cTxWeight, false );
            }


          });
    });

    telphone.on('keyup', function() {
          var telephoneVal = $(this).val();

      $('.phone').each(function() {

          var $this = $(this);
          var dataLine = $this.data('line'),
              cTxLineType = $this.data('class'),
              cTxFontSize = $this.data('fontsize'),
              cTxFontFamily = $(this).attr('data-fontface'),
              cTxColor = $this.attr('data-fontcolor'),
              cTxAlign = $this.data('alignment'),
              cTxWeight = $this.data('fontweight');

          $(this).attr('data-text', telephoneVal);

        if ( telephoneVal.length > 0  ) {
          $(this).prev('.divwidth').text(telephoneVal);
        }

        if ( $this.attr('data-emboss') != undefined ) {
          loadCanvasText( dataLine, cTxLineType, cTxFontSize, cTxFontFamily, cTxColor, telephoneVal, cTxAlign, cTxWeight, false, JSON.stringify($this.data('emboss')) );
        } else {
          loadCanvasText( dataLine, cTxLineType, cTxFontSize, cTxFontFamily, cTxColor, telephoneVal, cTxAlign, cTxWeight, false);
        }
      });

    });

    phone.on('keyup', function() {
          var phoneVal = $(this).val();

      $('.onlyphone').each(function() {

          var $this = $(this);
          var dataLine = $this.data('line'),
              cTxLineType = $this.data('class'),
              cTxFontSize = $this.data('fontsize'),
              cTxFontFamily = $(this).attr('data-fontface'),
              cTxColor = $this.attr('data-fontcolor'),
              cTxAlign = $this.data('alignment'),
              cTxWeight = $this.data('fontweight');

          $(this).attr('data-text', phoneVal);

        if ( phoneVal.length > 0  ) {
          $(this).prev('.divwidth').text(phoneVal);
        }

        if ( $this.attr('data-emboss') != undefined ) {
          loadCanvasText( dataLine, cTxLineType, cTxFontSize, cTxFontFamily, cTxColor, phoneVal, cTxAlign, cTxWeight, false, JSON.stringify($this.data('emboss')) );
        } else {
          loadCanvasText( dataLine, cTxLineType, cTxFontSize, cTxFontFamily, cTxColor, phoneVal, cTxAlign, cTxWeight, false);
        }
      });

    });

    email.on('keyup', function() {
          var emailVal = $(this).val();

      $('.onlyemail').each(function() {

          var $this = $(this);
          var dataLine = $this.data('line'),
              cTxLineType = $this.data('class'),
              cTxFontSize = $this.data('fontsize'),
              cTxFontFamily = $(this).attr('data-fontface'),
              cTxColor = $this.attr('data-fontcolor'),
              cTxAlign = $this.data('alignment'),
              cTxWeight = $this.data('fontweight');

          $(this).attr('data-text', emailVal);

        if ( emailVal.length > 0  ) {
          $(this).prev('.divwidth').text(emailVal);
        }

        if ( $this.attr('data-emboss') != undefined ) {
          loadCanvasText( dataLine, cTxLineType, cTxFontSize, cTxFontFamily, cTxColor, emailVal, cTxAlign, cTxWeight, false, JSON.stringify($this.data('emboss')) );
        } else {
          loadCanvasText( dataLine, cTxLineType, cTxFontSize, cTxFontFamily, cTxColor, emailVal, cTxAlign, cTxWeight, false);
        }
      });

    });

    jerseynumber.on('keyup', function() {
          var jerseyVal = $(this).val();

      $('.jerseynumber').each(function() {

          var $this = $(this);
          var dataLine = $this.data('line'),
              cTxLineType = $this.data('class'),
              cTxFontSize = $this.data('fontsize'),
              cTxFontFamily = $(this).attr('data-fontface'),
              cTxColor = $this.attr('data-fontcolor'),
              cTxAlign = $this.data('alignment'),
              cTxWeight = $this.data('fontweight');

          $(this).attr('data-text', jerseyVal);

        if ( jerseyVal.length > 0  ) {
          $(this).prev('.divwidth').text(jerseyVal);
        }

        if ( $this.attr('data-emboss') != undefined ) {
          loadCanvasText( dataLine, cTxLineType, cTxFontSize, cTxFontFamily, cTxColor, jerseyVal, cTxAlign, cTxWeight, false, JSON.stringify($this.data('emboss')) );
        } else {
          loadCanvasText( dataLine, cTxLineType, cTxFontSize, cTxFontFamily, cTxColor, jerseyVal, cTxAlign, cTxWeight, false);
        }
      });

    });
    //=========Customizer - On Click Events=========





    function lineSpanGetData ( ) {
        console.log("lineSpanGetData");
        $('.line-span').each(function() {
            var lbdataLine = $(this).data('line'),
                lbLineType = $(this).data('class'),
                lbFontSize = $(this).data('fontsize'),
                lbText = $(this).data('text'),
                lbColor = $(this).attr('data-fontcolor'),
                lbFontFamily = $(this).attr('data-fontface'),
                lbAlign = $(this).data('alignment'),
                lbWeight = $(this).data('fontweight');

              if ( $(this).hasClass('fullname') ) {
                    loadCanvasFull( lbdataLine, lbLineType, lbFontSize, lbFontFamily, lbColor, lbText, lbAlign, lbWeight, false);
              } else {
                    loadCanvasText( lbdataLine, lbLineType, lbFontSize, lbFontFamily, lbColor, lbText, lbAlign, lbWeight, false);
              }
        });
    }


    $('.label_option_checkbox.label_option').find('input[type="checkbox"]').on('click', function(e) {

      var vPrice = $('span.product-price-minimum.money').attr("data-currency-usd");
      var vnumber = Number(vPrice.replace(/[^0-9\.-]+/g,""));
      console.log("vnumber = " + vnumber);
      var tnumber = vnumber + 5;
          var shopCurrency = Shop.currency;
      var moneyFormat = Currency.cookie.read();
      if(moneyFormat === null){
          moneyFormat = 'USD';
      }

      if(moneyFormat != 'USD'){
        $('span.product-price-minimum.money').removeAttr("data-currency-"+moneyFormat.toLowerCase());
      }
      if($('.label_option_checkbox.label_option').find('input[type="checkbox"]:checked').val()){
          $('.label_option_checkbox.label_option').find('input[type="hidden"]').attr('value','✓');
        $('.step4').append("<div class='label_option_total' style='display: inline-block;'><input type='hidden' name='properties[_labelVariantNames]' data-property-name='_labelVariantNames' value='Laminate add on'><input type='hidden' name='properties[_labelVariantIds]' data-property-name='_labelVariantIds' value='36690383693'><input type='hidden' name='properties[_labelProductIds]' data-property-name='_labelProductIds' value='9806318413'><input type='hidden' name='properties[_labelVariantPrices]' data-property-name='_labelVariantPrices' value='500'><input type='hidden' name='properties[_labelVariantQtys]' data-property-name='_labelVariantQtys' value=''><input type='hidden' name='properties[_labelProductOneTime]' data-property-name='_labelProductOneTime' value=''><input type='hidden' name='properties[_labelOrderOneTime]' data-property-name='_labelOrderOneTime' value=''></div>");
        $('span.product-price-minimum.money').attr("data-currency", "USD").text('$' + tnumber.toFixed(2));
        $('.cart-lightbox .primary-product .price').text('$' + tnumber.toFixed(2));
      }else{
        $('.label_option_checkbox.label_option').find('input[type="hidden"]').attr('value','');
        $('.step4').find('.label_option_total').remove();
        $('span.product-price-minimum.money').attr("data-currency", "USD").text('$' + vnumber.toFixed(2));
        $('.cart-lightbox .primary-product .price').text('$' + vnumber.toFixed(2));
      }


      Currency.convertAll(shopCurrency, moneyFormat);
      //$('span.product-price-minimum.money').text(vPrice.charAt(0)+ tnumber.toFixed(2));
    });

    /* Converted icon select to thumbnails 
    $('select.swatch-icon').on('change', function(e) {
        e.preventDefault();
  //      $(this).find('input[type="radio"]').prop('checked', 'checked');


        $(this).find('img').addClass('is-selected');
        $(this).parents('.label_option_value').siblings().find('label').find('img').removeClass('is-selected');



        var iconTitle = $(this).val();
        var swatchIconSrc = asset_url[0] + "icon_basic_55x55_" + iconTitle.toLowerCase().replace(/\s/g,"") + '.png' + asset_url[1];

        //var swatchIconSrc = $(this).find('img').attr('src');
        iconLabelSelected = $(this).val().toLowerCase().replace(/\s/g,'');

        if ( iconLabelSelected.indexOf('noicon') > -1 ) {
            iconLabelSelected = 'default';
        }     

        if ( isBGWhite ) {
          var labelBGSrc = asset_url[0] + productTagC + "_basic_white_" + iconLabelSelected + '-bg_700x700.png' + asset_url[1];
          bgBackground = labelBGSrc;
        } else {
          var labelBGSrc = asset_url[0] + productTagC + "_basic_transparent_" + iconLabelSelected + '-bg_700x700.png' + asset_url[1];
          bgBackground = labelBGSrc;
        }

        image = new Image();  
        // Load image and draw it to canvas
        image.onload = function(){
            context.clearRect(0, 0, canvas.width, canvas.height);
            context.restore();
            context.fillStyle= bgBackgroundColor;
            context.fillRect(0,0,canvas.width, canvas.height);        
            context.drawImage(image, 0, 0, canvas.width, canvas.height);
        }
        image.src = bgBackground;      

        image = new Image();  
        // Load image and draw it to canvas
        image.onload = function(){
            context1.clearRect(0, 0, canvas1.width, canvas1.height);
            context1.restore();
            context1.fillStyle= bgBackgroundColor;
            context1.fillRect(0,0,canvas1.width, canvas1.height);        
            context1.drawImage(image, 0, 0, canvas1.width, canvas1.height);
        }
        image.src = bgBackground;     

        // Load image and draw it to thumbnail canvas
          image = new Image();
        image.onload = function(){
            thumb_context.clearRect(0, 0, thumb_canv.width, thumb_canv.height);
            thumb_context.restore();
            thumb_context.fillStyle= bgBackgroundColor;
            thumb_context.fillRect(0,0,thumb_canv.width, thumb_canv.height);        
            thumb_context.drawImage(image, 0, 0, thumb_canv.width, thumb_canv.height);
        }
        image.src = bgBackground;   
          $('#thumb_canv').parents('a').attr('href', bgBackground).attr('color', bgBackgroundColor);

       // $('.product-main-image').find('img.main-img').attr('src',labelBGSrc);
       // $('.line-span').
        var iconFontColor = $('.line-span').attr('data-fontcolor'),
            iconFontFamily = $('.line-span').attr('data-fontface'); 

        if ( basicTag != '' ) {
            var basicTagSplit = basicTag.split('|');
            var valSwatchIcon = '';        

            $.each(basicTagSplit, function(key,value) {
                if ( iconLabelSelected === value.toLowerCase() ) {
                   valSwatchIcon = '_'+iconLabelSelected;
                    return false;
                } 
            });

            callBasicJson(productTagCollection.toLowerCase()+valSwatchIcon , iconFontColor , iconFontFamily);             

        } else {
            callBasicJson(productTagCollection.toLowerCase(), iconFontColor , iconFontFamily);    
        }
        $('.basic-line-properties').html('');
        $('.basic-line-properties').prepend('<input type="hidden" class="collection-type" name="properties[_Icon URL]" value="'+ swatchIconSrc +'">');    
      if($('.license-line-properties').find('input[name="properties[Icon]"]').length){
        $('.license-line-properties').find('input[name="properties[Icon]"]').val($(this).val());
      }else{
        $('.license-line-properties').prepend('<input type="hidden" class="collection-type" name="properties[Icon]" value="' + $(this).val() + '">');
      }
    });*/

    $('.swatch-icon').find('label').on('click', function(e) {
        e.preventDefault();
        $(this).find('input[type="radio"]').prop('checked', 'checked');

        $(this).find('img').addClass('is-selected');
        $(this).parents('.label_option_value').siblings().find('label').find('img').removeClass('is-selected');

        //Update color swatches for selected icon
        var colorType = $('#Swatch-colortype').val();
        var selectedIcon = $(this).find('input[type="radio"]').val().replace(/\s/g, '');;
        showColorSwatches(selectedIcon, colorType);  

        var iconFontColor = $('.line-span').attr('data-fontcolor'),
        iconFontFamily = $('.line-span').attr('data-fontface'); 

        //console.log("color vis: " + 'input[type="radio"].Color[data-hex="' + bgBackgroundColor + '"]');
        //temp = $('input[type="radio"].Color[data-hex="' + bgBackgroundColor + '"]');
        //console.log(temp.parents('.label_option_value'));
        /*if ($('input[type="radio"].Color[data-hex="' + bgBackgroundColor + '"]').parents('.label_option_value').is(":visible")) {
        }
        else {
          bgBackgroundColor = bgBackgroundColorDefault;
          iconFontColor = "ffffff";
        }
        console.log("bgBackgroundColor: " + bgBackgroundColor);

        if ($('input[type="radio"].Color[data-hex="#' + iconFontColor + '"]').parents('.label_option_value').is(":visible")) {
        }
        else if (iconFontColor != "ffffff") {
          iconFontColor = bgBackgroundColorDefault.replace("#","");
        }*/

        var swatchIconSrc = $(this).find('img').attr('src');
        iconLabelSelected = selectedIcon.toLowerCase().replace(/\s/g,'');

        /*if ( iconLabelSelected.indexOf('noicon') > -1 ) {
            iconLabelSelected = 'default';
        }*/ 

        if ( isBGWhite ) {
          var labelBGSrc = asset_url[0] + productTagC + "_basic_white_" + iconLabelSelected + '-bg_700x700.png' + asset_url[1];
          bgBackground = labelBGSrc;
        } else {
          var labelBGSrc = asset_url[0] + productTagC + "_basic_" + iconLabelSelected + '-bg_700x700.png' + asset_url[1];
          bgBackground = labelBGSrc;
          bgBackgroundColor = "#ffffff";
        }
        console.log("bgBackground: " + bgBackground);

        image = new Image();  
        // Load image and draw it to canvas
        image.onload = function(){
            context.clearRect(0, 0, canvas.width, canvas.height);
            context.restore();
            context.fillStyle= bgBackgroundColor;
            context.fillRect(0,0,canvas.width, canvas.height);        
            context.drawImage(image, 0, 0, canvas.width, canvas.height);
        }
        image.src = bgBackground;       

        image = new Image();  
        // Load image and draw it to canvas
        image.onload = function(){
          context1.clearRect(0, 0, canvas1.width, canvas1.height);
          context1.restore();
          context1.fillStyle= bgBackgroundColor;
          context1.fillRect(0,0,canvas1.width, canvas1.height);        
          context1.drawImage(image, 0, 0, canvas1.width, canvas1.height);
        }
        image.src = bgBackground;     

        // Load image and draw it to thumb canvas
        image = new Image(); 
        image.onload = function(){
          thumb_context.clearRect(0, 0, thumb_canv.width, thumb_canv.height);
          thumb_context.restore();
          thumb_context.fillStyle= bgBackgroundColor;
          thumb_context.fillRect(0,0,thumb_canv.width, thumb_canv.height);        
          thumb_context.drawImage(image, 0, 0, thumb_canv.width, thumb_canv.height);
        }
        image.src = bgBackground; 
      	$('#thumb_canv').parents('a').attr('href', bgBackground);

        // $('.product-main-image').find('img.main-img').attr('src',labelBGSrc);
        // $('.line-span').

        var collectionJSON = productTagC + "_basic_" + iconLabelSelected;
        var productTagJson = collectionJSON.toLowerCase();
        console.log("productTagJson: swatch-icon.click" + productTagJson);

        console.log("iconFontColor = " + iconFontColor);
      console.log("basicTag: " + basicTag);
        if ( basicTag != '' ) {
            var basicTagSplit = basicTag.split('|');
            var valSwatchIcon = '';        

            $.each(basicTagSplit, function(key,value) {
                if ( iconLabelSelected === value.toLowerCase() ) {
                   valSwatchIcon = '_'+iconLabelSelected;
                    return false;
                } 
            });

            //callBasicJson(productTagCollection.toLowerCase()+valSwatchIcon , iconFontColor , iconFontFamily);                    
        }

        loadCPJSONValues(productTagJson,'',true,iconFontFamily);

        var defaultIconColor = $('input[type="radio"].Color.' + selectedIcon + '.default').val();    
        if($('.license-line-properties').find('input[name="properties[Label Color]"]').length){
          $('.license-line-properties').find('input[name="properties[Label Color]"]').val(defaultIconColor);
        }else{
          $('.license-line-properties').prepend('<input type="hidden" class="collection-type" name="properties[Label Color]" value="' + defaultIconColor + '">');
        }

        var defaultFontColor = $('input[type="radio"].Color.' + selectedIcon + '.default').data('fontcolor');
        console.log('defaultFontColor: ' + defaultFontColor);
        if($('.license-line-properties').find('input[name="properties[Font Color]"]').length){
          $('.license-line-properties').find('input[name="properties[Font Color]"]').val(defaultFontColor);
        }else{
          $('.license-line-properties').prepend('<input type="hidden" class="collection-type" name="properties[Font Color]" value="' + defaultFontColor + '">');
        }

        $('.basic-line-properties').html('');
        $('.basic-line-properties').prepend('<input type="hidden" class="collection-type" name="properties[_Icon URL]" value="'+ swatchIconSrc +'">');

    });

    $('select.swatch-colortype').on('change', function(e) {

      var selectedIcon = "";
      selectedIcon = $('.swatch-icon img.is-selected').siblings('.label_option_value_title').text().replace(/\s/g, '');    
      console.log("selectedIcon: " + selectedIcon);

      if (selectedIcon == '') {
        selectedIcon = 'no-icon';
      }

      var data = $(this).val();
      console.log('data = ' + data);
      $('.color-option-container').show();

      showColorSwatches(selectedIcon, data);

      if(data == 'White')
        $('input[value="Black"].White').parents('label').trigger('click');
    });

    function showColorSwatches(selectedIcon, colorType) {
      $('input[type="radio"].Color').parents('.label_option_value').hide();
      if (selectedIcon != "")
          $('input[type="radio"].Color.' + selectedIcon + '.' + colorType).parents('.label_option_value').show();

      $('input[type="radio"].Color.All' + '.' + colorType).parents('.label_option_value').show(); 

      console.log('input[type="radio"].Color.' + selectedIcon + '.' + colorType);
    }

    $('.swatch-color').find('label').on('click', function(e) {
      e.preventDefault();
      //$(this).find('input[type="radio"]').prop('checked', 'checked');
      var FontColor, LabelColor;
      var lineSpan = $('.line-span');
      $(this).find('.colorhex').css({'border':'3px solid #9c0'});

      var colorHex = $(this).find('input[type="radio"]').data('hex').replace('#','');
      bgBackgroundColor = colorHex;

      if($(this).find('input[type="radio"]').hasClass('White')){
        console.log("White label");

        var basicColor = true;

        $(this).find('input[type="radio"]').parents('.label_option_value').siblings().find('.colorhex').css({'border':''});

        // $('.product-main-image').find('.main-img').css('background-color',"#"+colorHex);

        if ( iconLabelSelected.indexOf('default') > -1 ) {
          iconLabelSelected = 'no-icon';
        }
        isBGWhite = true;

        $('.line-container').css('color', '#000');
        $('.collection-fontcolor').show();
        $('.collection-fontcolor').find(':radio[value="Black"]').prop('checked','checked');  

        if ($(this).find('input[type="radio"]').data('background') === 'override') {
          bgBackground = asset_url[0] + productTagC + "_basic_white_" + bgBackgroundColor + "_" + iconLabelSelected + '-bg.png' + asset_url[1];      
          bgBackgroundColor = '#ffffff';
        } else {
          var labelBGSrc = asset_url[0] + productTagC + "_basic_white_" + iconLabelSelected + '-bg_700x700.png' + asset_url[1];
          bgBackground = labelBGSrc;
          bgBackgroundColor = '#'+colorHex;
        }
        //console.log('bgBackground: ' + bgBackground);

        lineSpan.attr('data-fontcolor', colorHex);
        FontColor = $(this).find('input[type="radio"]').data('fontcolor');
        //console.log('FontColor: ' + FontColor);
        LabelColor = $(this).find('input[type="radio"]').val();
      }else{
        //console.log("Non-white label - iconLabelSelected: " + iconLabelSelected);

        var basicBG = false;

        $(this).parents('.label_option_value').siblings().find('.colorhex').css({'border':''});

        var colorDefault = 'ffffff';

        if ( iconLabelSelected.indexOf('default') > -1 ) {
          iconLabelSelected = 'no-icon';
        }

        isBGWhite = false;
        $('.line-container').css('color', '#fff');
        $('.collection-fontcolor').hide();

        if ($(this).find('input[type="radio"]').data('background') === 'override') {
          var colorType = '';
          if($(this).find('input[type="radio"]').hasClass('Full_Color')){
            colorType = 'full-color';
          }

          bgBackground = asset_url[0] + productTagC + "_basic_" + colorType + "_" + bgBackgroundColor + "_" + iconLabelSelected + '-bg.png' + asset_url[1];
          bgBackgroundColor = '#ffffff';
        } else {
          var labelBGSrc = asset_url[0] + productTagC + "_basic_transparent_" + iconLabelSelected + '-bg_700x700.png' + asset_url[1];
          bgBackground = labelBGSrc;        
        }
        console.log('bgBackground: ' + bgBackground);

        if($(this).find('input[type="radio"]').hasClass('PASTEL')){
          colorDefault = '000000';
        }else{
          colorDefault = 'ffffff';
        }

        //$('.step3b').find('.collection-fontcolor').find('input[type=radio]').removeAttr('checked');     
        //$('.step3b').find('.collection-fontcolor').find('img').removeClass('is-selected');        

        //$('.collection-fontcolor').find(':radio[value="White"]').prop('checked','checked').css('visibility','hidden');           

        var iconfontColor = $(this).find('input[type="radio"]').data('fontcolor');
        //console.log('iconfontColor: ' + iconfontColor);
        if (typeof iconfontColor != 'undefined') {
          FontColor = iconfontColor;
        }
        else {
          FontColor = 'ffffff';
        }
        console.log('FontColor: ' + FontColor + colorDefault);

        lineSpan.attr('data-fontcolor', FontColor);

        LabelColor = $(this).find('input[type="radio"]').val();
      }
      //lineSpanGetData();

      // canvas bg    
      image = new Image();  
      // Load image and draw it to canvas
      image.onload = function(){
        context.clearRect(0, 0, canvas.width, canvas.height);
        context.restore();
        context.fillStyle= bgBackgroundColor;
        context.fillRect(0,0,canvas.width, canvas.height);        
        context.drawImage(image, 0, 0, canvas.width, canvas.height);
      }
      image.src = bgBackground;      

      image = new Image();  
      // Load image and draw it to canvas
      image.onload = function(){
        context1.clearRect(0, 0, canvas1.width, canvas1.height);
        context1.restore();
        context1.fillStyle= bgBackgroundColor;
        context1.fillRect(0,0,canvas1.width, canvas1.height);        
        context1.drawImage(image, 0, 0, canvas1.width, canvas1.height);
      }
      image.src = bgBackground;     

      // Load image and draw it to thumb canvas
      image = new Image(); 
      image.onload = function(){
        thumb_context.clearRect(0, 0, thumb_canv.width, thumb_canv.height);
        thumb_context.restore();
        thumb_context.fillStyle= bgBackgroundColor;
        thumb_context.fillRect(0,0,thumb_canv.width, thumb_canv.height);        
        thumb_context.drawImage(image, 0, 0, thumb_canv.width, thumb_canv.height);
      }
      image.src = bgBackground;  

      $('#thumb_canv').parents('a').attr('href', bgBackground).attr('color', bgBackgroundColor);

      if($('.license-line-properties').find('input[name="properties[Label Color]"]').length){
          $('.license-line-properties').find('input[name="properties[Label Color]"]').val(LabelColor);
      }else{
        $('.license-line-properties').prepend('<input type="hidden" class="collection-type" name="properties[Label Color]" value="' + LabelColor + '">');
      }
      if($('.license-line-properties').find('input[name="properties[Font Color]"]').length){
          $('.license-line-properties').find('input[name="properties[Font Color]"]').val(FontColor);
      }else{
        $('.license-line-properties').prepend('<input type="hidden" class="collection-type" name="properties[Font Color]" value="' + FontColor + '">');
      }

      var collectionJSON = productTagC + "_basic_" + iconLabelSelected;
      var productTagJson = collectionJSON.toLowerCase();
      console.log("productTagJson: swatch-color.click " + productTagJson);

      loadCPJSONValues(productTagJson,FontColor,true);

    });


    $('select.swatch-font').on('change', function(e) {
        e.preventDefault();
        //$(this).find('input[type="radio"]').prop('checked', 'checked');    
          var basicFont = true;
          var fontFamily = $(this).val().toLowerCase();
          var lineOne = 'line1';
          var lineSpan = $('.line-span');
          $('.line-span').find('.line-container').css('font-family',fontFamily);
          $(this).find('img').addClass('is-selected');
          $(this).parents('.label_option_value').siblings('.label_option_value').find('img').removeClass('is-selected');

          lineSpan.attr('data-fontface', fontFamily);
          lineSpanGetData();

        var fontLabelSelected = fontFamily.replace(/\s/g,'');
        if ( basicFontTag != '' ) {
            var basicTagSplit = basicFontTag.split('|');
            var valSwatchFont = '';        
            var fontMatch = '';

            $.each(basicTagSplit, function(key,value) {
                if ( fontLabelSelected === value.toLowerCase() ) {

                   valSwatchFont = productTagCollection.toLowerCase()+'_'+fontLabelSelected;
                   fontMatch = fontLabelSelected;
                }
            });

          if ( fontMatch === fontLabelSelected ) {

              $.ajax({
                  type: 'GET',
                  url: newCPLoc,
                  dataType: 'json',
                  success: function(results) {
                        var cpLocResult = results;

                        $.each(cpLocResult[valSwatchFont], function(key, value) {
                            var lineType = value.class;

                              $('.'+key).css({
                                'height': value.height,
                                'display': 'block',
                                'width': value.width,
                                'left': value.xcoordinate,
                                'top': value.ycoordinate,
                                'height': value.height
                              });

                        });
                  }
              });                    
          }        
        }   
      if($('.license-line-properties').find('input[name="properties[Font Style]"]').length){
        $('.license-line-properties').find('input[name="properties[Font Style]"]').val($(this).find('option:selected').text());
      }else{
        $('.license-line-properties').prepend('<input type="hidden" class="collection-type" name="properties[Font Style]" value="' + $(this).find('option:selected').text() + '">');
      }
    });

   //============Step 1 - Personal Info Textbox===========
    var getUrlParameter = function getUrlParameter(sParam) {
        var sPageURL = decodeURIComponent(window.location.search.substring(1)),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

        for (i = 0; i < sURLVariables.length; i++) {
          sParameterName = sURLVariables[i].split('=');

          if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : sParameterName[1];
          }
        }
    };


    var loadSpecialJson = getUrlParameter('json');
    var whichLogo = getUrlParameter('brand');
    var productTagJson;

    if ( loadSpecialJson ) {
          productTagJson = loadSpecialJson.toLowerCase();
    } else if (hasBasic) {
          productTagJson = productTagCollection.toLowerCase() + '_basic_no-icon';        
    } else {
          productTagJson = productTagCollection.toLowerCase() + '_noicon';
    }

    if (!whichLogo) {
      console.log('if (!whichLogo productTagJson: '+ productTagJson);
        $.ajax({
            type: 'GET',
            url: newCPLoc,
            dataType: 'json',
            success: function(results) {
              var cpLocResult = results;

          $.each(cpLocResult[productTagJson], function(key, value) {
            console.log('cpLocResult[productTagJson]: ' + productTagJson);
              var lineType = value.class,
                  cpDefaultValue = value.default;
              var collectionFontFamily1;
              var fontColorHx1;

              if ( String(key).indexOf('line') > -1 ) {
                  if ( value.class == 'address' ) {
                      cpDefaultValue = value.default
                  }
                      var lineSpan = $('<div class="divwidth text-width'+key+'" style="font-size:'+value.fontsize/2+'px; line-height:'+(value.fontsize*1.4)+'px">'+value.default+'</div><span class="line-span '+ lineType + " " + key + " " + value.move +'" data-move="'+value.ycoordinate+'" data-line="'+key+'" data-class="'+value.class+'" data-text="'+value.default+'" data-fontsize="'+value.fontsize+'" data-fontface="'+value.fontfamily+'" data-fontcolor="'+value.fontcolor+'" data-fontweight="'+value.fontweight+'" data-alignment="'+value.alignment+'" data-width="'+value.width+'" style="font-family:'+value.fontfamily+'"><img class="cpimg img'+key+'" style="float:'+value.alignment+'"> </span>');
                lineDiv.append(lineSpan);
                $('.'+key).css({
                  'height': value.height,
                  'display': 'block',
                  'width': value.width,
                  'left': value.xcoordinate,
                  'top': value.ycoordinate,
                  'height': value.height
                });

                  //for emboss 

                if ( value.hasOwnProperty('emboss') ) {
                    isLineEmboss = true;
                    lineEmbossArr = value.emboss;
                    fontColorHx1 = value.fontcolor;
                    collectionFontFamily1 = value.fontfamily;
                    $('.'+key).attr('data-emboss',JSON.stringify(value.emboss))
                              .attr('data-fontcolor', fontColorHx1 )
                              .attr('data-fontface', collectionFontFamily1);
                } else if ( value.hasOwnProperty('usedefaultfont') && value.usedefaultfont === 'false' ) {
                    fontColorHx1 = value.fontcolor;
                    collectionFontFamily1 = value.fontfamily;
                    $('.'+key).attr('data-fontcolor', fontColorHx1 )
                              .attr('data-fontface', collectionFontFamily1);
                }                    

                if ( lineType === 'fullname' || lineType === 'allergies') {
                            loadCanvasFull( key, lineType, value.fontsize, value.fontfamily, value.fontcolor, value.default, value.alignment, value.fontweight, true, JSON.stringify(value.emboss));
                      } else if ( lineType === 'address' ) {
                            loadCanvasAddress( key, lineType, value.fontsize, value.fontfamily, value.fontcolor, value.default, value.extraline, value.alignment, value.fontweight, true, JSON.stringify(value.emboss));
                } else {
                            loadCanvasText( key, lineType, value.fontsize, value.fontfamily, value.fontcolor, value.default, value.alignment, value.fontweight, true, JSON.stringify(value.emboss));
                }

                  $('.line-label').attr({'data-fontstyle':value.fontfamily, 'data-color':value.fontcolor});

             }
          });

            }
        });

    }

    //=========Accordion Style===============

    // Add headers for radio buttons and textbox e.g. radio=Collection, Icon, Label... textbox=like FullName, Allergy...

    $('.label_option_set').find('.label_option_textbox').each ( function() {
      $(this).addClass('enter-info')
    });

    $('.label_option_set').find('.label_option_telephone').addClass('enter-info');
    $('.enter-info:not(.half)').wrapAll('<div class="step1 accordion-content active"></div>');

    $('.label_option_set').find('.swatch-collection').parents('.label_option').addClass('design-info').addClass('step2');
    $('.label_option_set').find('.swatch-style').parents('.label_option').addClass('design-info').addClass('step2');

    $('.label_option_set').find('.swatch-icon, .swatch-label, .swatch-font, .swatch-colortype').parents('.label_option').addClass('style-info').addClass('step3b').css('display','none');
    $('.label_option_set').find('.swatch-color').parents('.collection-color').addClass('color-option-container').addClass('step4a').css('display','none');

    $('.label_option_set').find('.swatch-icon').parents('.style-info').addClass('style-icon');


    if ( categoryLabel === '' ) {
        $('.step2 h3').html('Choose Your Design');
    } else {
        $('.step2 h3').html(categoryLabel);
    }

    if ( textLabel === '' ) {
        $('.step1').before('<h3 class="label-title label-info title-active">Enter name for labels</h3>');
        $('.half').first().prepend('<h3 class="label-title label-info title-active">Enter name for labels</h3>');
    } else {
        $('.step1').before('<h3 class="label-title label-info title-active">'+textLabel+'</h3>')
    }

      if ( $('.twostep-style').length === 0 ) {
        $('.step2').after('<div class="step3a accordion-content label_option '+iconColumn+'"></div>');
      }

      if ( $('.step3b').length == 0 ) {
          $('.label-title.label-style').hide();
          $('.step3a').hide();
      }

    if ( $('.label_option_set').find('.label_option_checkbox').length > 0 ) {
      $('.label_option_set').find('.label_option_checkbox').addClass('add-on');
      //$('.add-on').wrapAll('<div class="step5 accordion-content"></div>');
      $('.step5').before('<h3 class="label-title label-addon">Special add-on</h3>');
    }

    if(userNeedToSelectOptionFirstError){
      $('.license-line-properties').append('<input type="text" required="true" value="" style="display:none" class="licenseline-property">');

      $('.add-to-cart').on('click', function() {
        if ( $('.licenseline-property').length > 0 ) {
          console.log('error1');

          $('.error-prodmsg').show().text('Please choose your icon...');
          return false;
        }
      });
    }

    loadAllIcons();


    $('.label-title').on('click', function() {
      $(this).addClass('title-active');
      $(this).siblings('.label-title').removeClass('title-active');
    });

    $('.label-style').on('click', function(e) {
        if (  $(this).hasClass('licensed-collection-selected') ) {

          $('.step3a').show();
          $('.team-container').show();
          $('.step3b').hide();
          $('.team-option-container').find('h3').removeClass('title-active');
      } else if ( $(this).hasClass('basic-collection-selected') ) {
          $('.swatch-collection').find('.basic').find('label').trigger('click');
      }
        else {
           $('.swatch-collection').find('.no-icon').find('label').trigger('click');
      }

    });

    var teamArray = [];

    function loadAllIcons () {

       $.ajax({
          type: 'GET',
          url: newCCLoc,
          dataType: 'json',
          success: function(results) {
            console.log("newCCLoc = " + newCCLoc);
            var jasonObject = results;
            var step3bContent = "<div class='team-option-container step3a'><h3 class='label-title'>Choose your logo</h3>";
            var step3bAllContent = "<div class='all-team-container'>";
            var step3bTitle = "<select class='team-sports team-container'>";
            var step3bAllTitle = "<div class='all-team' style='display:none'>";                    
            var teamLogo = '';

            $('.step3a').show();
           // $('.step3b').hide();

            if ( $('.step3b').length != 0 ) {
              $('.step3a').show();
              $('.step3b').hide();
            }          

            $.each( jasonObject, function ( key, value ) {
                var valueLogoTrunc = value.logo;
                teamLogo = value.logo;

                var teamValue = value.team;
                var teamOption = value.option;
                var backgroundImage = '';

                if ( value.backgroundimage != '') {
                    backgroundImage = value.backgroundimage + theImageSuffix;              
                } else {
                    backgroundImage = productTagC.replace('_','-') + "_" + teamLogo.toLowerCase() + "_" + teamValue.replace(/\s/g,'-') + "_" + teamOption + '-bg.png' + theImageSuffix;                 
                }            

                var jsonurl = '/products/'+productTagC.replace('_','-')+'?brand='+value.logo+'&team='+value.team+'&option='+value.option+'&icon='+value.featuredimage+'&hover='+value.featuredimagehover+'&bgimage='+backgroundImage.toLowerCase()+'&fontcolor='+value.fontcolor+'&fontstyle='+value.fontfamily+'&json='+value.json;
                  if(teamValue != '')
                  {
                      teamArray.push([teamValue, value.logo]);
                  }
                step3bContent += '<label class="team-logo '+ teamValue.replace(/\s/g,"-").toLowerCase() +' '+ teamLogo.toLowerCase() +'" data-team-group="'+teamLogo.toLowerCase()+'"><a href="'+jsonurl+'" data-image="'+backgroundImage.toLowerCase()+'" data-fontface="'+value.fontfamily+'" data-json="'+value.json+'" data-fontcolor="'+value.fontcolor+'" data-team="'+teamValue+'" data-teamoption="'+teamOption+'" class="collection-logo-option"><img src="' + asset_url[0] + 'icon_'  + value.logo + '_55x55_' + teamValue.toLowerCase().replace(/\s/g,'-') + '_' + teamOption.toLowerCase().replace(/\s/g,'-') + '.png' + asset_url[1]  +'" alt="'+ teamValue + ' ' +value.option +'"></a><br></label>';            

            });

            step3bContent += "</div>";

            step3bTitle += "</select>";

            if(teamArray.length){
              $('.step3a').html( '<h3 class="label-title team-container">' + subCategoryLabel + '</h3>' + step3bTitle);
            }else{
              $('.step3a').html('');
              var num = parseInt($('.step3a').find('.step-number').text())-1;
              $('.step3a').find('.step-number').text(num.toString()); 
            }
            $('.step3a').after(step3bContent);

            if ( iconLabel === '' ) {
              $('.team-option-container.step3a h3').html('Choose your icon');
            } else {
              $('.team-option-container.step3a h3').html(iconLabel);
            }         

            $('.team-option-container').find('.team-logo').on('click', function() {
              $('.step3a').prev('h3.label-title').removeClass('title-active');
              $('.team-option-container').find('h3').addClass('title-active');
              $('.error-prodmsg').hide();
            });
            
            if($('.swatch-collection').find('.label_option_value').length == 1){
              //Hide swatch-collection if it only contains 1 option
              console.log("hide swatch collection");
              $('.swatch-collection').parent('.label_option').hide();
              setTimeout(function () {
                //Trigger selection of swatch
                $('.swatch-collection').val($('.swatch-collection').find('.label_option_value').val()).trigger('change');
              }, 1000);   
            }

            loadClickEvents();

          }
        }); 
    }

    function loadClickEvents() {

      $('select.team-sports').on('change',function() {

          var dataHref = $(this).val();
          var thisClassTeam = $(this).find(":selected").attr('class').replace('team','').trim();

          console.log('select.team-sports on change - dataHref = ' + dataHref + 'thisClassTeam = ' + thisClassTeam);
          $('.team-option-container').show();
          $('.team-logo:not(.'+dataHref+'.'+thisClassTeam+')').hide();
          $('.'+dataHref+'.'+thisClassTeam).show();

          if ( $('.'+dataHref+'.'+thisClassTeam).length <= 1 ) {
            console.log("click <=1");
            $('.'+dataHref+'.'+thisClassTeam).find('a.collection-logo-option').click();
            $('.team-option-container').hide();
          } else {
            console.log("click else");
            $('.team-option-container').show();
            var icon = $('.'+dataHref+'.'+thisClassTeam).find('a.collection-logo-option');
            icon[0].click();
          }

          $('.step3a').prev('h3.label-title').removeClass('title-active');
          $('.team-option-container').find('h3').addClass('title-active');

          if ( $('.step3a.accordion-content.adjust-icon-width').find('.team-option-container').length != 0 ) {
            if ( $('.step4container').length == 0 ) {
              $('.step3a.accordion-content.adjust-icon-width').find('.team-option-container').find('label').wrapAll('<div class="step4container"></div>');
            }
          }                

      });

      $('.collection-logo-option').on('click', function(e) {
          console.log("collection-logo-opt: " + this);
          e.preventDefault();

          if (userNeedToSelectOptionFirst ) {
            $('input.add-to-cart').prop("disabled", false);
          }

          var $thisIcon = $(this).find('img').attr('src');
          var collectionBG = $(this).data('image');
          var collectionFontFamily = $(this).attr('data-fontface');
          var collectionFontColor = $(this).attr('data-fontcolor');
          var collectionBGSrc = asset_url[0] + collectionBG + asset_url[1];
          var collectionJSON = $(this).data('json');
          var collectionBGSplit = collectionBG.split('.');
          var collectionBGSource = asset_url[0] + collectionBGSplit[0] + "." + collectionBGSplit[1];
          var loadOption = $(this).data('teamoption');
          var loadTeam = $(this).data('team');
          var fontColorHx = '';
		  bgBackground = collectionBGSource;

          if ( collectionFontColor === 'Black' ) {
            fontColorHx = '000000';
          } else if (  collectionFontColor === 'White' ) {
            fontColorHx = 'ffffff';
          } else {
            fontColorHx = collectionFontColor;
          }

          $(this).find('img').css({'border':'1px solid #9c0','border-radius':'5px'});
          $(this).parents('label').siblings('label').find('img').css({'border':'1px solid #fff','border-radius':'5px'});


          image = new Image();
          // Load image and draw it to canvas
          image.onload = function(){
            context.clearRect(0, 0, canvas.width, canvas.height);
            context.restore();
            context.fillStyle="#ffffff";
            context.fillRect(0,0,canvas.width, canvas.height);        
            context.drawImage(image, 0, 0, canvas.width, canvas.height);
          }
          image.src = collectionBGSource;  

          image = new Image();  
          // Load image and draw it to canvas
          image.onload = function(){
            context1.clearRect(0, 0, canvas1.width, canvas1.height);
            context1.restore();
            context1.fillStyle= "#ffffff";
            context1.fillRect(0,0,canvas1.width, canvas1.height);        
            context1.drawImage(image, 0, 0, canvas1.width, canvas1.height);
          }
          image.src = collectionBGSource; 

          // Load image and draw it to thumbnail canvas
          image = new Image();
          image.onload = function(){
            thumb_context.clearRect(0, 0, thumb_canv.width, thumb_canv.height);
            thumb_context.restore();
            thumb_context.fillStyle="#ffffff";
            thumb_context.fillRect(0,0,thumb_canv.width, thumb_canv.height);        
            thumb_context.drawImage(image, 0, 0, thumb_canv.width, thumb_canv.height);
          }
          image.src = collectionBGSource;
          $('#thumb_canv').parents('a').attr('href', collectionBGSource).attr('color', "#ffffff");



          $('.line-span').find('.line-container').css({'color': fontColorHx, 'font-family': collectionFontFamily.toLowerCase()});

          if ( collectionJSON ) {
            var productTagJson = collectionJSON.toLowerCase();
          } else {
            var productTagJson = productTagCollection.toLowerCase();
          }
          console.log("productTagJson: collection-logo-option.click" + productTagJson);

          $('.license-line-properties').html('');
          $('.basic-line-properties').html('');

          $('.license-line-properties').prepend('<input type="hidden" class="collection-type" name="properties[Choose Collection]" value="' + $('select.swatch-collection').val() +'">');
          $('.license-line-properties').prepend('<input type="hidden" class="collection-type" name="properties[Option]" value="'+ loadOption +'">');
          $('.license-line-properties').prepend('<input type="hidden" class="collection-type" name="properties[Team]" value="'+ loadTeam +'">');
          $('.license-line-properties').prepend('<input type="hidden" class="collection-type" name="properties[_Icon URL]" value="'+ $thisIcon +'">');


          lineDiv.html('');

          loadCPJSONValues(productTagJson,fontColorHx,false,collectionFontFamily);
      });

    }

    function loadStyleLinks () {

       $.ajax({
          type: 'GET',
          url: newCCLoc,
          dataType: 'json',
          success: function(results) {
            var jasonObject = results;


          //   var step3bContent = "<div class='team-option-container'><h3 class='bold_option_title label-title label-style'>"+stepFourLabel+"</h3>";
          //   var step3bAllContent = "<div class='all-team-container'>";
          //   var step3bTitle = "<div class='team-container'><span class='bold_option_title'></span><div class='team-sports'></div></div>";
          //   var step3bAllTitle = "<div class='all-team' style='display:none'>";
          //   var teamArray = [];
          //   var teamLogo = '';


            $.each( results, function ( key, value ) {
              //console.log( value );


                var valueLogoTrunc = value.logo,
                      backgroundImage = '';

                if ( value.backgroundimage != '') {
                    backgroundImage = value.backgroundimage;
                } else {
                    backgroundImage = productTagC.replace('_','-') + "_" + valueLogoTrunc.toLowerCase() + '-bg.png'+theImageSuffix;
                }

              //   step3bContent += '<label class="team-logo '+ teamValue.replace(/\s/g,"-").toLowerCase() +' '+ teamLogo.toLowerCase() +'" data-team-group="'+teamLogo.toLowerCase()+'">
              //<a href="'+jsonurl+'" data-image="'+backgroundImage.toLowerCase()+theImageSuffix+'" data-fontface="'+value.fontfamily+'" data-json="'+value.json+'" data-fontcolor="'+value.fontcolor+'" data-team="'+teamValue+'" data-teamoption="'+teamOption+'" class="collection-logo-option"><img src="' + asset_url[0] + 'icon_'  + value.logo + '_55x55_' + teamValue.toLowerCase().replace(/\s/g,'-') + '_' + teamOption.toLowerCase().replace(/\s/g,'-') + '.png'+ theImageSuffix + '" alt="'+ teamValue + ' ' +value.option +'"></a><br></label>';

              $('.twostep-style').find( '.label_option_value.'+value.logo ).find('label').attr({
                  'data-image': backgroundImage.toLowerCase()+theImageSuffix,
                  'data-fontface': value.fontfamily,
                  'data-json': value.json,
                  'data-fontcolor': value.fontcolor,
                  'data-team': value.team,
                  'data-teamoption': value.option,				
              }).addClass('collection-logo-option');


            });


          } // ajax success end
        });
    }


    //====Step 2 - Choosing the Logo and some Ajax Stuff====

    $('select.swatch-collection').on('change', function(e) {
      e.preventDefault();

      isBGWhite = false;		    
      bgBackgroundColor = '#FFFFFF';   

      var logoVal = $(this).val(),
      truncatedLogo = logoVal.toLowerCase();
      console.log("logoVal = " + logoVal);

      //============ExtraPriceChange start====================
      var priceView = $(this).find('.label_option_value_price');
      if(priceView.length > 0 ){
        var vPrice = $('span.product-price-minimum.money').attr("data-currency-usd");
        var vnumber = Number(vPrice.replace(/[^0-9\.-]+/g,""));
        var tnumber = vnumber;
        $('.label_option_total').remove();

        var extraPrice = priceView.find('.money')[0].innerHTML;
        console.log("extraPrice = " +extraPrice);
        var variantid, variantprice;
        if(extraPrice == '$20.00'){
          variantid = 40991866573;
          variantprice = 2000;
          tnumber = vnumber + 20;
        }else if(extraPrice == '$48.00'){
          variantid = 40991866637;
          variantprice = 4800;
          tnumber = vnumber + 48;
        }else if(extraPrice == '$66.00'){
          variantid = 40991866445;
          variantprice = 6600;
          tnumber = vnumber + 66;
        }else if(extraPrice == '$85.50'){
          variantid = 40991866381;
          variantprice = 8550;
          tnumber = vnumber + 85.5;
        }
        $('.step4').append("<div class='label_option_total' style='display: inline-block;'><input type='hidden' name='properties[_labelVariantNames]' data-property-name='_labelVariantNames' value='" + logoVal + "'><input type='hidden' name='properties[_labelVariantIds]' data-property-name='_labelVariantIds' value='" + variantid + "'><input type='hidden' name='properties[_labelProductIds]' data-property-name='_labelProductIds' value='10518757773'><input type='hidden' name='properties[_labelVariantPrices]' data-property-name='_labelVariantPrices' value='" + variantprice + "'><input type='hidden' name='properties[_labelVariantQtys]' data-property-name='_labelVariantQtys' value=''><input type='hidden' name='properties[_labelProductOneTime]' data-property-name='_labelProductOneTime' value=''><input type='hidden' name='properties[_labelOrderOneTime]' data-property-name='_labelOrderOneTime' value=''></div>");



        var shopCurrency = Shop.currency;
        var moneyFormat = Currency.cookie.read();
        if(moneyFormat === null){
            moneyFormat = 'USD';
        }

        if(moneyFormat != 'USD'){
          $('span.product-price-minimum.money').removeAttr("data-currency-"+moneyFormat.toLowerCase());
        }
        $('span.product-price-minimum.money').attr("data-currency", "USD").text('$' + tnumber.toFixed(2));



        Currency.convertAll(shopCurrency, moneyFormat);

      }
      //============ExtraPriceChange end================

      var thisVal = logoVal.toLowerCase().replace(/\s/g,'-');

      // Reset all values
      //$('.step3b').find('input[type=radio]').removeAttr('checked');     
      //$('.step3b').find('img').removeClass('is-selected');


      if ( logoVal.indexOf('Basic') > -1 ) {
          console.log("logoVal.indexOf('Basic')");

          $('.step3b').show();
          $('.step3a').hide();
          //console.log('logoVal: ' + logoVal);
          $('.step3b').find('.style-icon').show();

        $('.step3b').find('select').val('');

          if ( $('.collection-type').length > 0 ) {
            $('.collection-type').remove();
          }

        //$('.collection-fontcolor').find(':radio[value="White"]').prop('checked','checked').css('visibility','hidden');

        bgBackground = asset_url[0] + productTagC + "_basic_no-icon-bg_700x700.png" + asset_url[1];     
        bgBackgroundColor = "#FFFFFF";

        image = new Image();
        // Load image and draw it to canvas
        image.onload = function(){
            context.clearRect(0, 0, canvas.width, canvas.height);
            context.restore();
            context.fillStyle= bgBackgroundColor;
            context.fillRect(0,0,canvas.width, canvas.height);        
            context.drawImage(image, 0, 0, canvas.width, canvas.height);
        }
        image.src = bgBackground;

        image = new Image();  
        // Load image and draw it to canvas
        image.onload = function(){
          context1.clearRect(0, 0, canvas1.width, canvas1.height);
          context1.restore();
          context1.fillStyle= bgBackgroundColor;
          context1.fillRect(0,0,canvas1.width, canvas1.height);        
          context1.drawImage(image, 0, 0, canvas1.width, canvas1.height);
        }
        image.src = bgBackground; 

        // Load image and draw it to canvas
        image = new Image();
        image.onload = function(){
            thumb_context.clearRect(0, 0, thumb_canv.width, thumb_canv.height);
            thumb_context.restore();
            thumb_context.fillStyle=bgBackgroundColor;
            thumb_context.fillRect(0,0,thumb_canv.width, thumb_canv.height);        
            thumb_context.drawImage(image, 0, 0, thumb_canv.width, thumb_canv.height);
        }
        image.src = bgBackground;
        $('#thumb_canv').parents('a').attr('href', bgBackground);


        var productTagJson = productTagCollection.toLowerCase() + "_basic_no-icon";
        lineDiv.html('');

        loadCPJSONValues(productTagJson,'',true,"Bebas Kai");
        //callBasicJson(productTagJson+'_noicon', false, false);

  // 		$('.collection-fontcolor').find(':radio[value="White"]').prop('checked','checked');
  //      $('.collection-label').find(':radio[value="Orange"]').prop('checked','checked').css('visibility','hidden');
  //      $('.collection-font').find(':radio[value="Impact"]').prop('checked','checked');      
          $('.license-line-properties').html('');
          if($('.swatch-font').length)
              $('.license-line-properties').prepend('<input type="hidden" class="collection-type" name="properties[Font Style]" value="Clean">');
          if($('.swatch-color').length){
              var defaultFontColor = $('input[type="radio"].Color.no-icon.default').data('fontcolor');
              $('.license-line-properties').prepend('<input type="hidden" class="collection-type" name="properties[Font Color]" value="' + defaultFontColor + '">');
              var defaultcolor = $('input[type="radio"].Color.no-icon.default').val();
              $('.license-line-properties').prepend('<input type="hidden" class="collection-type" name="properties[Label Color]" value="' + defaultcolor + '">');
          }
          if($('.swatch-collection').length)
              $('.license-line-properties').prepend('<input type="hidden" class="collection-type" name="properties[Choose Collection]" value="' + $(this).val() +'">');

      }else if( logoVal.indexOf('No Icon') > -1 ){
          console.log("logoVal.indexOf('No Icon')");
          $('.step3b').show();
          $('.step3a').hide();
          //$('.step3a').find('h3').hide();
          //$('.step3a').find('select').hide();
          $('.step3b.style-icon').hide();
          $('.step3b').find('.collection-fontcolor').hide();

          iconLabelSelected = 'default';

          if ( $('.collection-type').length > 0 ) {
            $('.collection-type').remove();
          }

          setTimeout(function () {
              $('.product-main-image').find('img.main-img').css('background-color','#ADADAD');  
          }, 200);   

          //$('.product-main-image').find('img.main-img').attr('src',asset_url[0] + productTagC + '_basic_transparent_default-bg_700x700.png' + asset_url[1]);
        bgBackground = asset_url[0] + productTagC + '_basic_transparent_default-bg_700x700.png' + asset_url[1];
        image = new Image();  
        // Load image and draw it to canvas
        image.onload = function(){
            context.clearRect(0, 0, canvas.width, canvas.height);
            context.restore();
            context.fillStyle="#ADADAD";
            context.fillRect(0,0,canvas.width, canvas.height);        
            context.drawImage(image, 0, 0, canvas.width, canvas.height);
        }
        image.src = bgBackground; 

        image = new Image();  
        // Load image and draw it to canvas
        image.onload = function(){
          context1.clearRect(0, 0, canvas1.width, canvas1.height);
          context1.restore();
          context1.fillStyle= "#ADADAD";
          context1.fillRect(0,0,canvas1.width, canvas1.height);        
          context1.drawImage(image, 0, 0, canvas1.width, canvas1.height);
        }
        image.src = bgBackground; 


        // Load image and draw it to canvas
        image = new Image(); 
        image.onload = function(){
            thumb_context.clearRect(0, 0, thumb_canv.width, thumb_canv.height);
            thumb_context.restore();
            thumb_context.fillStyle="#ADADAD";
            thumb_context.fillRect(0,0,thumb_canv.width, thumb_canv.height);        
            thumb_context.drawImage(image, 0, 0, thumb_canv.width, thumb_canv.height);
        }
        image.src = bgBackground; 
        $('#thumb_canv').parents('a').attr('href', bgBackground).attr('color', "#ADADAD");


          var productTagJson = productTagCollection.toLowerCase();
          lineDiv.html('');

          callBasicJson(productTagJson+'_basic_no-icon', false, false);      

          $('.license-line-properties').html('');

  //    	$('.collection-fontcolor').find(':radio[value="White"]').prop('checked','checked');
  //    	$('.collection-label').find(':radio[value="Orange"]').prop('checked','checked').css('visibility','hidden');
  //     	$('.collection-font').find(':radio[value="Impact"]').prop('checked','checked');
          if($('.swatch-collection').length)
              $('.license-line-properties').prepend('<input type="hidden" class="collection-type" name="properties[Choose Collection]" value="' + $(this).val() +'">');
          if($('.swatch-font').length)
              $('.license-line-properties').prepend('<input type="hidden" class="collection-type" name="properties[Font Style]" value="Clean">');
          if($('.swatch-color').length){
            $('.license-line-properties').prepend('<input type="hidden" class="collection-type" name="properties[Font Color]" value="White">');
            $('.license-line-properties').prepend('<input type="hidden" class="collection-type" name="properties[Label Color]" value="Gray1">');
          }

      }else{
        $('.step3b').hide();
        $('.step3a').show();
        $('.step4a').hide();


        $('.license-line-properties').html('<input type="text" required="true" value="" style="display:none" class="licenseline-property">');

        //Populate team-sports subcategory dropdown		
        $('.team-sports').empty();
        $('.team-sports').append("<option style='display:none;' value='' disabled selected>Select...</option>");
        $.each( teamArray, function( key, value ) {
          if (truncatedLogo === value[1])
             $('.team-sports').append('<option class="team '+ value[1] +'" value="'+ value[0].replace(/\s/g,"-").toLowerCase() +'">' +value[0]+ '</option>');
        });


        if($('.team-sports').find('.team.'+truncatedLogo).length > 0){

          $('option.team').each(function() {
            var $this = $(this);
            var thisHref = $(this).val();
            var thisClassSel = $(this).attr('class').replace('team','').trim();
            if ( $("option.team."+thisClassSel+"[value='"+thisHref+"']").length > 1 ) {
              $this.remove();
            }
          });        

          $('.team-container').css('display','inline-block');

          //$('.team-sports').html( $('.all-team').find('.team.'+truncatedLogo).clone() );
          //$('.team-sports').val('');
          //$('.team-sports').find('.team.'+truncatedLogo).show();
          //$('.team-sports').find('.team:not(.'+truncatedLogo + ')').hide();        
          //$('.team-sports').prepend('<option style="display:none;" value="" disabled selected>Select...</option>');

        }
        else {
          $('.team-container').css('display','none');
        }

        $('.add-to-cart').on('click', function() {
          if ( $('.licenseline-property').length > 0 ) {
            console.log('error2');

            $('.error-prodmsg').show().text('Please choose your icon...').delay(1500).fadeOut();
            return false;
          }
        });     

        console.log('thisVal = ' + thisVal);
        // Set the Title/Sub title for each collection                                   
        $('.text-category').find('li').each( function( key,value ) {
          var thisLi = $(this).attr('class');
          var thisLiVal = $(this).text();
          if ( thisLi === thisVal ) {
            $('.team-container.label-title').html(thisLiVal); 
          }
        });

        $(this).parents('.step2').next('.label-title').addClass('step2done licensed-collection-selected');
        $(this).parents('.step2').siblings('.step3a').addClass('licensed-collection-selected');

      }

      if($('.team-sports').find('.' + truncatedLogo).length == 0){
        $(this).parents('.step2').prev('.label-title').removeClass('title-active');

        $('.team-option-container').show();
        $('.team-logo:not(.'+truncatedLogo+')').hide();
        $('.team-logo.'+ truncatedLogo).show();

        if ( $('.'+truncatedLogo).length <= 1 ) {
          $('.'+truncatedLogo).find('a.collection-logo-option').click();

          $('.team-option-container').hide();
        } else {
          $('.team-option-container').show();
          var icon = $('.'+truncatedLogo).find('a.collection-logo-option');
          icon[0].click();
        }

        $('.step3a').prev('h3.label-title').removeClass('title-active');
        $('.team-option-container').find('h3').addClass('title-active');

        if ( $('.step3a.accordion-content.adjust-icon-width').find('.team-option-container').length != 0 ) {
          if ( $('.step4container').length == 0 ) {
            $('.step3a.accordion-content.adjust-icon-width').find('.team-option-container').find('label').wrapAll('<div class="step4container"></div>');
          }
        }  
      }else if($('.team-sports').find('.' + truncatedLogo).length == 1){
          $('.team-sports').find('label.team.' + truncatedLogo).click();
          //var s = $('.all-team').find('.team.' + logoVal);
          //$('.'+s.data('href')+'.'+logoVal).find('a.collection-logo-option').click();

          $('.label-title.label-style').hide();
          $('.step3a').hide();

      }else{
          $('.team-option-container').hide();
          $(this).parents('.step2').prev('.label-title').removeClass('title-active');
          $(this).parents('.step2').next('.label-title').addClass('title-active step2done');

      }


    });

    function loadCPJSONValues(productTagJson,fontColorHx,basicIcon,collectionFontFamily) {
          console.log("loadCPJSONValues - productTagJson:" + productTagJson);

      	  $('.line-label').show(); //In case it has been hidden when viewing other thumbnails
          lineDiv.html(''); 

          $.ajax({
            type: 'GET',
            url: newCPLoc,
            dataType: 'json',
            success: function(results) {
              var cpLocResult = results;
              //console.log(cpLocResult);

              $.each(cpLocResult[productTagJson], function(key, value) {
                var collectionFontFamily1 = collectionFontFamily;
                var fontColorHx1 = fontColorHx;
                //console.log("ch(cpLocResult[productTagJs");
                var lineType = value.class;
                if ( String(key).indexOf('line') > -1 ) {
                  //console.log(String(key));
                  var inputVal = value.default;
                  var divWidthVal = value.default;

                  if ( value.class === 'firstname' ) {
                    if ( firstName.val().length != 0  ) {
                      inputVal = firstName.val();
                      divWidthVal = firstName.val();
                    }
                  } else if ( value.class === 'lastname' ) {
                    if ( lastName.val().length != 0  ) {
                      inputVal = lastName.val();
                      divWidthVal = lastName.val();
                    }
                  } else if ( value.class === 'phone' ) {
                    if ( telphone.val().length != 0  ) {
                      inputVal = telphone.val();
                      divWidthVal = telphone.val();
                    }
                  }
                  else if ( value.class === 'onlyphone' ) {
                    if ( phone.val().length != 0  ) {
                      inputVal = phone.val();
                      divWidthVal = phone.val();
                    }
                  }
                  else if ( value.class === 'onlyemail' ) {
                    if ( email.val().length != 0  ) {
                      inputVal = email.val();
                      divWidthVal = email.val();
                    }
                  }else if ( value.class == 'fullname' ) {
                    if ( fullName.length != 0 && fullName.val().length != 0  ) {
                      inputVal = fullName.val();
                      divWidthVal = fullName.val();
                    }
                  } else if ( value.class == 'longname' ) {
                    if ( fullName.length != 0 && fullName.val().length != 0  ) {
                      inputVal = fullName.val();
                      divWidthVal = fullName.val();
                    } else if ( justName.length != 0 && justName.val().length != 0 ) {
                      inputVal = justName.val();
                      divWidthVal = justName.val();
                    }
                  } else if ( value.class == 'allergies' ) {
                    if ( allergies.val().length != 0  ) {
                      inputVal = allergies.val();
                      divWidthVal = allergies.val();
                    }
                  } else if ( value.class == 'monogram' ) {
                    if ( monogram.val().length != 0  ) {
                      inputVal = monogram.val();
                      divWidthVal = monogram.val();
                    }
                  }else if ( value.class == 'text1' ) {
                    if ( text1.val().length != 0  ) {
                      inputVal = text1.val();
                      divWidthVal = text1.val();
                    }
                  }else if ( value.class == 'text2' ) {
                    if ( text2.val().length != 0  ) {
                      inputVal = text2.val();
                      divWidthVal = text2.val();
                    }
                  }else if ( value.class == 'text3' ) {
                    if ( text3.val().length != 0  ) {
                      inputVal = text3.val();
                      divWidthVal = text3.val();
                    }
                  }else if ( value.class == 'text4' ) {
                    if ( text4.val().length != 0  ) {
                      inputVal = text4.val();
                      divWidthVal = text4.val();
                    }    
                  }else if ( value.class == 'text5' ) {
                    if ( text5.val().length != 0  ) {
                      inputVal = text5.val();
                      divWidthVal = text5.val();
                    }                             
                  }else if ( value.class == 'address' ) {
                    if ( singleAddress.val().length != 0 || cityAddress.val().length != 0  ) {
                      singleAddVal = singleAddress.val();
                      cityAddVal = cityAddress.val();
                    } else {
                      singleAddVal = value.default;
                      cityAddVal = value.extraline;
                    }
                  }

                  if ( typeof(value.usedefaultfont) !== 'undefined' && value.usedefaultfont === 'false') {
                    if ($('select.swatch-font').val() != null && basicIcon) {
                      collectionFontFamily1 = $('select.swatch-font').val();
                    } else {         			
                      collectionFontFamily1 = value.fontfamily;
                    }
                    if (!basicIcon || fontColorHx1 === '')
                      fontColorHx1 = value.fontcolor;
                  }

                  //console.log("value.ycoordinate: " + value.ycoordinate);
                  var lineSpan = $('<div class="divwidth text-width'+key+'" style="font-size:'+value.fontsize/2+'px; line-height:'+(value.fontsize*1.4)+'px">'+divWidthVal+'</div><span class="line-span '+ lineType + " " + key + " " + value.move +'" data-move="'+value.ycoordinate+'" data-line="'+key+'" data-class="'+value.class+'" data-text="'+inputVal+'" data-fontsize="'+value.fontsize+'" data-fontface="'+collectionFontFamily1+'" data-fontcolor="'+fontColorHx1+'" data-fontweight="'+value.fontweight+'" data-alignment="'+value.alignment+'" data-width="'+value.width+'" style="font-family:'+collectionFontFamily1+'"><img class="cpimg img'+key+'" style="float:'+value.alignment+'"></span>');
                  lineDiv.append(lineSpan);
                  $('.'+key).css({
                    'height': value.height,
                    'display': 'block',
                    'width': value.width,
                    'left': value.xcoordinate,
                    'top': value.ycoordinate,
                    'height': value.height
                  });

                  if ( value.hasOwnProperty('emboss') ) {
                    isLineEmboss = true;
                    lineEmbossArr = value.emboss;
                    fontColorHx1 = value.fontcolor;
                    collectionFontFamily1 = value.fontfamily;
                    $('.'+key).attr('data-emboss',JSON.stringify(value.emboss))
                    .attr('data-fontcolor', fontColorHx1 )
                    .attr('data-fontface', collectionFontFamily1);
                  } 

                  //console.log("fontColorHx1: " + fontColorHx1);
                  //console.log("fontColorHx: " + fontColorHx);
                  //console.log("lineType: " + lineType);
                  if ( lineType === 'fullname' || lineType === 'allergies' ) {
                    loadCanvasFull( key, lineType, value.fontsize, collectionFontFamily1, fontColorHx1, inputVal, value.alignment, value.fontweight, false, JSON.stringify(value.emboss));
                  } else if ( lineType === 'address' ) {
                    loadCanvasAddress( key, lineType, value.fontsize, collectionFontFamily1, fontColorHx1, singleAddVal, cityAddVal, value.alignment, value.fontweight, false, JSON.stringify(value.emboss));
                  } else {
                    loadCanvasText( key, lineType, value.fontsize, collectionFontFamily1, fontColorHx1, inputVal, value.alignment, value.fontweight, false, JSON.stringify(value.emboss));
                  }
                }

              });
              $('.line-label').attr({'data-fontstyle':collectionFontFamily, 'data-color':fontColorHx});
            }
          });

    }

      if ( $('.swatch-style').length != 0 ) {
          loadStyleLinks();

          $('.swatch-style').find('label').on('click', function() {
              $(this).find('img').addClass('style-active');
              $(this).parents('.label_option_value').siblings('.label_option_value').find('img').removeClass('style-active');


              var $thisIcon = $(this).find('img').attr('src');
              var collectionBG = $(this).data('image');
              var collectionFontFamily = $(this).attr('data-fontface');
              var collectionFontColor = $(this).attr('data-fontcolor');
              var collectionBGSrc = asset_url[0] + collectionBG;
              var collectionJSON = $(this).data('json');
              var collectionBGSplit = collectionBG.split('.');
              var collectionBGSource = asset_url[0] + collectionBGSplit[0] + "." + collectionBGSplit[1];
              var fontColorHx = '';
              bgBackground = collectionBGSource;

              if ( collectionFontColor === 'Black' ) {
                  fontColorHx = '000000';
              } else if (  collectionFontColor === 'White' ) {
                  fontColorHx = 'ffffff';
              } else {
                  fontColorHx = collectionFontColor;
              }

              // $(this).find('img').css({'border':'1px solid #9c0','border-radius':'5px'});
              // $(this).parents('label').siblings('label').find('img').css({'border':'1px solid #fff','border-radius':'5px'});


            image = new Image();
              //$('.product-main-image').find('img.main-img').attr('src', collectionBGSource ).css('background-color','#fff');
              // Load image and draw it to canvas
            image.onload = function(){
                context.clearRect(0, 0, canvas.width, canvas.height);
                context.restore();
                context.fillStyle="#ffffff";
                context.fillRect(0,0,canvas.width, canvas.height);
                context.drawImage(image, 0, 0, canvas.width, canvas.height);
            }
            image.src = collectionBGSource;

            image = new Image();  
            // Load image and draw it to canvas
            image.onload = function(){
              context1.clearRect(0, 0, canvas1.width, canvas1.height);
              context1.restore();
              context1.fillStyle= "#ffffff";
              context1.fillRect(0,0,canvas1.width, canvas1.height);        
              context1.drawImage(image, 0, 0, canvas1.width, canvas1.height);
            }
            image.src = collectionBGSource; 

            // Load image and draw it to canvas
            image = new Image();
            image.onload = function(){
                thumb_context.clearRect(0, 0, thumb_canv.width, thumb_canv.height);
                thumb_context.restore();
                thumb_context.fillStyle="#ffffff";
                thumb_context.fillRect(0,0,thumb_canv.width, thumb_canv.height);
                thumb_context.drawImage(image, 0, 0, thumb_canv.width, thumb_canv.height);
            }
            image.src = collectionBGSource;
            $('#thumb_canv').parents('a').attr('href', collectionBGSource).attr('color', "#ffffff");


              $('.line-span').find('.line-container').css({'color': fontColorHx, 'font-family': collectionFontFamily.toLowerCase()});

              if ( collectionJSON ) {
                  var productTagJson = collectionJSON.toLowerCase();
              } else {
                  var productTagJson = productTag.toLowerCase();
              }

              $('.license-line-properties').html('');
                $('.basic-line-properties').html('');
              $('.license-line-properties').prepend('<input type="hidden" class="collection-type" name="properties[Choose Collection]" value="' + $('select.swatch-collection').val() +'">');
              $('.license-line-properties').prepend('<input type="hidden" class="collection-type" name="properties[_Icon URL]" value="'+ $thisIcon +'">');

              lineDiv.html('');

              $.ajax({
                  type: 'GET',
                  url: newCPLoc,
                  dataType: 'json',
                  success: function(results) {
                        var cpLocResult = results;

                          if ( lineDiv.html() === '' ) {
                              $.each(cpLocResult[productTagJson], function(key, value) {
                              var lineType = value.class,
                              isLineEmboss = false,
                              lineEmbossArr = {};

                              if ( String(key).indexOf('line') > -1 ) {
                              var inputVal = value.default;
                              var divWidthVal = value.default;

                              if ( value.class === 'firstname' ) {
                              if ( firstName.val().length != 0  ) {
                                  inputVal = firstName.val();
                                  divWidthVal = firstName.val();
                              }
                              } else if ( value.class === 'lastname' ) {
                              if ( lastName.val().length != 0  ) {
                                  inputVal = lastName.val();
                                  divWidthVal = lastName.val();
                              }
                              } else if ( value.class === 'phone' ) {
                              if ( telphone.val().length != 0  ) {
                                  inputVal = telphone.val();
                                  divWidthVal = telphone.val();
                              }
                              } else if ( value.class === 'onlyphone' ) {
                              if ( phone.val().length != 0  ) {
                                  inputVal = phone.val();
                                  divWidthVal = phone.val();
                              }
                              } else if ( value.class === 'onlyemail' ) {
                              if ( email.val().length != 0  ) {
                                  inputVal = email.val();
                                  divWidthVal = email.val();
                              }
                              } else if ( value.class == 'fullname' ) {
                              if ( fullName.val().length != 0  ) {
                                  inputVal = fullName.val();
                                  divWidthVal = fullName.val();
                              }
                              } else if ( value.class == 'longname' ) {
                              if ( fullName.val().length != 0  ) {
                                  inputVal = fullName.val();
                                  divWidthVal = fullName.val();
                              }
                              } else if ( value.class == 'allergies' ) {
                              if ( allergies.val().length != 0  ) {
                                  inputVal = allergies.val();
                                  divWidthVal = allergies.val();
                              }
                              } else if ( value.class == 'monogram' ) {
                              if ( monogram.val().length != 0  ) {
                                  inputVal = monogram.val();
                                  divWidthVal = monogram.val();
                              }
                              } else if ( value.class == 'text1' ) {
                              if ( text1.val().length != 0  ) {
                                  inputVal = text1.val();
                                  divWidthVal = text1.val();
                              }
                              } else if ( value.class == 'text2' ) {
                              if ( text2.val().length != 0  ) {
                                  inputVal = text2.val();
                                  divWidthVal = text2.val();
                              }
                              }else if ( value.class == 'text3' ) {
                                if ( text3.val().length != 0  ) {
                                  inputVal = text3.val();
                                  divWidthVal = text3.val();
                              }
                              }else if ( value.class == 'text4' ) {
                                if ( text4.val().length != 0  ) {
                                  inputVal = text4.val();
                                  divWidthVal = text4.val();
                              }  
                              }else if ( value.class == 'text5' ) {
                                if ( text5.val().length != 0  ) {
                                  inputVal = text5.val();
                                  divWidthVal = text5.val();
                              }                                
                              } else if ( value.class == 'address' ) {
                              if ( address.val().length != 0  ) {
                                  inputVal = address.val();
                                  divWidthVal = address.val();
                              }
                              }

                              var lineSpan = $('<div class="divwidth text-width'+key+'" style="font-size:'+value.fontsize/2+'px; line-height:'+(value.fontsize*1.4)+'px">'+divWidthVal+'</div><span class="line-span '+ lineType + " " + key + " " + value.move +'" data-move="'+value.ycoordinate+'" data-line="'+key+'" data-class="'+value.class+'" data-text="'+inputVal+'" data-fontsize="'+value.fontsize+'" data-fontface="'+collectionFontFamily+'" data-fontcolor="'+fontColorHx+'" data-fontweight="'+value.fontweight+'" data-alignment="'+value.alignment+'" data-width="'+value.width+'"><img class="cpimg img'+key+'" style="float:'+value.alignment+'"></span>');
                              lineDiv.append(lineSpan);
                              $('.'+key).css({
                                  'height': value.height,
                                  'display': 'block',
                                  'width': value.width,
                                  'left': value.xcoordinate,
                                  'top': value.ycoordinate,
                                  'height': value.height
                              });

                              if ( value.hasOwnProperty('emboss') ) {
                                  isLineEmboss = true;
                                  lineEmbossArr = value.emboss;
                                  fontColorHx = value.fontcolor;
                                  collectionFontFamily = value.fontfamily;
                                  $('.'+key).attr('data-emboss',JSON.stringify(value.emboss))
                                      .attr('data-fontcolor', fontColorHx )
                                      .attr('data-fontface', collectionFontFamily);
                              } else if ( value.hasOwnProperty('usedefaultfont') && value.usedefaultfont === 'false' ) {
                                  fontColorHx = value.fontcolor;
                                  collectionFontFamily = value.fontfamily;
                                  $('.'+key).attr('data-fontcolor', fontColorHx )
                                      .attr('data-fontface', collectionFontFamily);
                              }

                                  if ( lineType === 'fullname' || lineType === 'allergies' || lineType === 'address' ) {

                                      loadCanvasFull( key, lineType, value.fontsize, collectionFontFamily, fontColorHx, inputVal, value.alignment, value.fontweight, false, JSON.stringify(value.emboss));
                                  } else {
                                      loadCanvasText( key, lineType, value.fontsize, collectionFontFamily, fontColorHx, inputVal, value.alignment, value.fontweight, false, JSON.stringify(value.emboss));
                                  }
                              }
                              $('.line-label').attr({'data-fontstyle':collectionFontFamily, 'data-color':fontColorHx});

                              });
                          }

                  }
              });
            });
      }

    //========Step 3b - Ready-Made Settings (Collection and Branded Images)========


    var loadTeam = getUrlParameter('team'),
        loadOption = getUrlParameter('option'),
        loadLabelColor = getUrlParameter('labelcolor'),
        loadBGImage = getUrlParameter('bgimage'),
        loadFontColor = getUrlParameter('fontcolor'),
        loadFontStyle = getUrlParameter('fontstyle');
    var loadFontColorHex = '';

    setTimeout(function () {

      if ( whichLogo ) {
        console.log("whichLogo");
        if ( whichLogo != 'basic' ) {
          $('.product-main-image').css('background-color', '#ffffff');
          var loadedImageParts = loadBGImage.split('.');
          var fontWeight = 'normal';
          var labelBGSrc = asset_url[0] + loadBGImage + asset_url[1];
		  bgBackground = labelBGSrc;
          
          var iconBGSrc = asset_url[0] + "icon_" + whichLogo.toLowerCase() +"_55x55_" + loadTeam.toLowerCase().replace(/\s/g,'-') + "_" + loadOption.toLowerCase() + ".png" + asset_url[1];
          $('.license-line-properties').html('');

          $('.license-line-properties').prepend('<input type="hidden" class="collection-type" name="properties[Choose Collection]" value="' + $('select.swatch-collection').val() +'">');
          $('.license-line-properties').prepend('<input type="hidden" class="collection-type" name="properties[Option]" value="'+ loadOption +'">');
          $('.license-line-properties').prepend('<input type="hidden" class="collection-type" name="properties[Team]" value="'+ loadTeam +'">');
          $('.license-line-properties').prepend('<input type="hidden" class="collection-type" name="properties[_Icon URL]" value="'+ iconBGSrc +'">');      
          //  $('.product-main-image').css('background-color','#fff');
          // $('.product-main-image').find('img.main-img').attr('src',labelBGSrc).css('background-color','#fff');

          image = new Image();
          //$('.product-main-image').find('img.main-img').attr('src', collectionBGSource ).css('background-color','#fff');
          // Load image and draw it to canvas
          image.onload = function(){
            context.clearRect(0, 0, canvas.width, canvas.height);
            context.restore();
            context.fillStyle="#ffffff";
            context.fillRect(0,0,canvas.width, canvas.height);        
            context.drawImage(image, 0, 0, canvas.width, canvas.height);
          }
          image.src = labelBGSrc;        

          image = new Image();  
          // Load image and draw it to canvas
          image.onload = function(){
            context1.clearRect(0, 0, canvas1.width, canvas1.height);
            context1.restore();
            context1.fillStyle= "#ffffff";
            context1.fillRect(0,0,canvas1.width, canvas1.height);        
            context1.drawImage(image, 0, 0, canvas1.width, canvas1.height);
          }
          image.src = labelBGSrc; 

          // Load image and draw it to canvas
          image = new Image();
          image.onload = function(){
            thumb_context.clearRect(0, 0, thumb_canv.width, thumb_canv.height);
            thumb_context.restore();
            thumb_context.fillStyle="#ffffff";
            thumb_context.fillRect(0,0,thumb_canv.width, thumb_canv.height);        
            thumb_context.drawImage(image, 0, 0, thumb_canv.width, thumb_canv.height);
          }
          image.src = labelBGSrc; 
          $('#thumb_canv').parents('a').attr('href', labelBGSrc).attr('color', "#ffffff");

          if ( loadFontStyle === 'Times New Roman' ) {
            fontWeight = "bold";
          }


          if ( loadFontColor.toLowerCase() === 'black' ) {
            loadFontColorHex = '000000';
          } else if (  loadFontColor.toLowerCase() === 'white' ) {
            loadFontColorHex = 'ffffff';
          } else {
            loadFontColorHex = loadFontColor;
          }

          $('.line-label').find('span').css({'color': loadFontColorHex, 'font-family': loadFontStyle, 'font-weight': fontWeight});

          $('.step3b').hide();

          lineDiv.html('');

          $.ajax({
            type: 'GET',
            url: newCPLoc,
            dataType: 'json',
            success: function(results) {
              var cpLocResult = results;

              $.each(cpLocResult[productTagJson], function(key, value) {
                console.log("cResult[productTagJson], functi");
                var lineType = value.class;
                if ( String(key).indexOf('line') > -1 ) {
                  var inputVal = value.default;
                  var divWidthVal = value.default;

                  var lineSpan = $('<div class="divwidth text-width'+key+'" style="font-size:'+value.fontsize/2+'px; line-height:'+(value.fontsize*1.4)+'px">'+divWidthVal+'</div><span class="line-span '+ lineType + " " + key + " " + value.move +'" data-move="'+value.ycoordinate+'" data-line="'+key+'" data-class="'+value.class+'" data-text="'+inputVal+'" data-fontsize="'+value.fontsize+'" data-fontface="'+loadFontStyle+'" data-fontcolor="'+loadFontColorHex+'" data-fontweight="'+fontWeight+'" data-alignment="'+value.alignment+'" data-width="'+value.width+'"><img class="cpimg img'+key+'"></span>');
                  lineDiv.append(lineSpan);
                  $('.'+key).css({
                    'height': value.height,
                    'display': 'block',
                    'width': value.width,
                    'left': value.xcoordinate,
                    'top': value.ycoordinate,
                    'height': value.height
                  });

                  if ( lineType === 'fullname' || lineType === 'allergies' ) {
                    loadCanvasFull( key, lineType, value.fontsize, loadFontStyle, loadFontColorHex, inputVal, value.alignment, fontWeight, true);
                  } else {
                    loadCanvasText( key, lineType, value.fontsize, loadFontStyle, loadFontColorHex, inputVal, value.alignment, fontWeight, true);
                  }
                }
                $('.line-label').attr({'data-fontstyle':loadFontStyle, 'data-color':loadFontColorHex});

              });

            }
          });

          $('*[data-teamoption="' + loadOption + '"]').find('img').css({'border':'1px solid #9c0','border-radius':'5px'});
          $('*[data-teamoption="' + loadOption + '"]').parents('label').siblings('label').find('img').css({'border':'1px solid #fff','border-radius':'5px'});
        }
      } else {

        // 	$('.collection-fontcolor').find(':radio[value="White"]').prop('checked','checked');
        // 	$('.collection-label').find(':radio[value="Orange"]').prop('checked','checked').css('visibility','hidden');
        // 	$('.collection-font').find(':radio[value="Impact"]').prop('checked','checked');    
        if($('.swatch-font').length)
          $('.license-line-properties').prepend('<input type="hidden" class="collection-type" name="properties[Font Style]" value="Clean">');
        if($('.swatch-color').length){
          var defaultFontColor = $('input[type="radio"].Color.no-icon.default').data('fontcolor');
          $('.license-line-properties').prepend('<input type="hidden" class="collection-type" name="properties[Font Color]" value="' + defaultFontColor + '">');
          var defaultcolor = $('input[type="radio"].Color.no-icon.default').val();
          $('.license-line-properties').prepend('<input type="hidden" class="collection-type" name="properties[Label Color]" value="' + defaultcolor + '">');
        }
      }
    }, 1000);   

    var x= document.getElementsByClassName("add-to-cart");
    x[0].addEventListener("click", function() {

      console.log('add-to-cart click');
      if($('.label_error_message').length != 0 ){
          $('.label_error_message').remove();
      }

      var title = $('.label_option_title');


      for(var i=0; i<title.length;i++){
        if(title[i].innerHTML.indexOf('*') != -1){

          var select = title[i].innerHTML;

          var labelOption = $("input[name*='" + select.replace("*", "") + "']");
          var selectOption = $("select." + select.replace("*", ""));

          if(labelOption.length){
            if(labelOption[0].value == ""){
              labelOption.parents('.label_option').addClass('label_option_error');
              labelOption.parents('.label_option').append("<span class='label_error_message inputfield'>	<small>This option is required.</small></span>");
            }
          }
          else if(selectOption.length){
            if(selectOption[0].value == ""){
              selectOption.parents('.label_option').append("<span class='label_error_message selectfield'>	<small>This option is required.</small></span>");
            }
          }

          if($('.label_error_message:visible').length != 0){
            $('input.add-to-cart[type="submit"]').attr('type', 'button');
          }else {
            $('input.add-to-cart[type="button"]').attr('type', 'submit');
          }
        } else {

            var select = title[i].innerHTML;
            var labelOption = $("input[name*='" + select.replace("*", "") + "']");

            if (labelOption.length && !labelOption.val() && labelOption.hasClass("use-default")) {
              var placeHolder = labelOption.attr('placeholder');
              labelOption.val(placeHolder);
            }      

        }

      }
    });     


    var labelOptiontest = $('.label_options');
    var productOptionDiv = $('.product-quantity');
        labelOptiontest.before(productOptionDiv);

  }

      if ( shopifyTemplate == 'product' && userNeedToSelectOptionFirst ) {

          BOLD.options.app.on('add_to_cart_cloned', function(data){
              $('input.add-to-cart.label_clone').prop("disabled", false);
          });

          BOLD.options.app.on('adding_to_cart', function(data){

                if ( $('input.add-to-cart.label_hidden').is(':disabled') ) {

                  $('.error-prodmsg').show().text('please choose your design/style').delay(1500).fadeOut();
                }
          });

      }  	

      $('.product-thumbnails').find('img').on('click', function(e) {

              if ($(this).attr("alt") != 'variantimage_hidden') {
                e.preventDefault();
                var lk = $(this).parents('a').attr("href");

                var canvas = document.getElementById('canvas');
                var context = canvas.getContext('2d');
                var image;

                image = new Image();
                //$('.product-main-image').find('img.main-img').attr('src', collectionBGSource ).css('background-color','#fff');
                // Load image and draw it to canvas
                image.onload = function(){
                  context.clearRect(0, 0, canvas.width, canvas.height);
                  context.restore();
                  context.fillStyle="#ffffff";
                  context.fillRect(0,0,canvas.width, canvas.height);        
                  context.drawImage(image, 0, 0, canvas.width, canvas.height);
                }
                image.src = lk;        
                $('.line-label').hide();
              }
      });

      $('.product-thumbnails').find('canvas').on('click', function(e) {
          e.preventDefault();
          $('.line-label').show();
          var lk = $(this).parents('a').attr("href");
          var bg = $(this).parents('a').attr("color");

          var canvas = document.getElementById('canvas');
          var context = canvas.getContext('2d');
          var image;

          image = new Image();
          // Load image and draw it to canvas
          image.onload = function(){
            context.clearRect(0, 0, canvas.width, canvas.height);
            context.restore();
            context.fillStyle=bg;
            context.fillRect(0,0,canvas.width, canvas.height);        
            context.drawImage(image, 0, 0, canvas.width, canvas.height);
          }
          image.src = lk;        

      });
}